<template>
  <v-container fluid class="container-full-bg-gray">
    <v-row v-if="userData && userData.can_view_invoices">
      <v-col cols="12">
        <v-card class="elevation-12 rounded-top">
          <v-card-title class="pa-0" v-if="!is_mobile">
            <table-list-toolbar
              customClass="rounded-top"              
              :title="title"
              :actions="getActions"
              :groups="documentListActionGroups"
              :loading="loadingAction"
              :disabled="selected.length==0"
              :show_actions="(!this.permission.is_readonly || show_actions_ro())"
              @job-done="jobDone"
              @selected-action="selectedAction"
              :job_state="downloadJobState"
            > 

              <template v-slot:right_title_btn>
                <!-- v-if="permission.can_write" -->
                <v-btn
                  v-if="!permission.general.is_customer_consult"
                  @click="$router.push({ name: 'document-loader', params: { companydb_id: currentCompany.id } });"	
                  color="primary_blue"
                  class="white--text ml-5 upload-invoices"
                >
                  <v-icon left color="white" class="material-symbols-outlined" small>upload_file</v-icon>
                  Subir Facturas
                </v-btn>
              </template>

              <template v-slot:initial_btns>
                <v-tooltip
                  v-if="!permission.is_readonly && !got_feature('feature_hide_invoices') && (permission.general.can_admin || permission.is_employee) && got_feature('feature_move_thirds_to_accounting')"
                  top
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      name="proveedores"
                      color="primary"
                      icon
                      @click="$router.push({ name: 'supplier-list', params: { companydb_id: currentCompany.id } })"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <AppIcon
                        src="/navigation/suppliers_v2.svg"
                        :size="32"
                        :colorMap="{ '663399': 'primary', '66359B': 'primary' }"
                      />
                    </v-btn>
                  </template>
                  <span>{{ $t('App.suppliers') }}</span>
                </v-tooltip>

                <v-tooltip
                  v-if="!permission.is_readonly && !got_feature('feature_hide_out_invoice') && !got_feature('feature_hide_invoices') && (permission.general.can_admin || permission.is_employee) && got_feature('feature_move_thirds_to_accounting')"
                  top
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      name="clientes"
                      color="primary"
                      icon
                      @click="$router.push({ name: 'customer-list', params: { companydb_id: currentCompany.id } })"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <AppIcon
                        src="/navigation/clients_v2.svg"
                        :size="32"
                        :colorMap="{ '663399': 'primary', '66359B': 'primary' }"
                      />
                    </v-btn>
                  </template>
                  <span>{{ $t('App.customers') }}</span>
                </v-tooltip>

                <v-btn name="refrescar" color="primary" icon @click="refreshData()" :loading="loading">
                  <AppIcon
                    :src="require('@/assets/documents_refresh.svg')"
                    :size="32"
                    :colorMap="{ '66359B': 'primary' }"
                  />
                </v-btn>
                <div>
                  <v-tooltip v-if="userData.available_features['feature_miniatura_ampliada'] && preview_docs && permission.can_write && !is_mobile" top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn class="btn-minus-plus" @click="embedPdfSize('auto','100px')" :color="preview_docs?'secondary':'primary'" icon v-bind="attrs" v-on="on">
                        <AppIcon
                          :src="require('@/assets/zoom_out.svg')"
                          :size="16"
                          :colorMap="{ '66359B': 'primary' }"
                        />
                      </v-btn>
                    </template>
                    <span v-if="preview_docs">Disminuir miniatura</span>
                  </v-tooltip>
                </div>
                <div>
                  <v-tooltip v-if="permission.can_write && !is_mobile" top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn @click="preview_docs = !preview_docs; embedPdfSize(300,'auto')" icon v-bind="attrs" v-on="on">
                          <AppIcon
                            :src="preview_docs ? require('@/assets/preview_doc_active.svg') : require('@/assets/preview_doc.svg')"
                            :size="32"
                            :colorMap="{ '66359B': 'primary' }"
                          />
                      </v-btn>
                    </template>
                    <span v-if="preview_docs">Ocultar previsualización</span>
                    <span v-else>Previsualizar documentos</span>
                  </v-tooltip>
                </div>
                <div>
                  <v-tooltip v-if="userData.available_features['feature_miniatura_ampliada'] && preview_docs && permission.can_write && !is_mobile" top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn class="btn-minus-plus" @click="embedPdfSize(450,600)" :color="preview_docs?'secondary':'primary'" icon v-bind="attrs" v-on="on">
                        <AppIcon
                          :src="require('@/assets/zoom_in.svg')"
                          :size="16"
                          :colorMap="{ '66359B': 'primary' }"
                        />
                      </v-btn>
                    </template>
                    <span v-if="preview_docs">Ampliar miniatura</span>
                  </v-tooltip>
                </div>
                <ShowDownloadInvoicesFilesDialog 
                    v-if="got_feature('feature_cloud_documents')"
                    :currentCompany_id="currentCompany.id"
                > 
                  
                </ShowDownloadInvoicesFilesDialog>
                
                <ShowHideColumnsDialog
                    v-if="!permission.is_readonly && got_feature('feature_config_table_columns')"
                    :showHideDialog="columnConfigDialog"
                    :key="columnConfigDialog"
                    :companyId="currentCompany.id"
                    settingCode="document_list_headers"
                    @restored="onColumnsRestored"
                  >
                  <template v-slot:actions>
                    <copy-settings
                            @copy-settings="copySettings"
                            :cdb_id="currentCompany.id"
                            code="document_list_headers"
                            :copying="copying"
                            v-if="userData.available_features['feature_copy_config_from_cdb']"
                    ></copy-settings>
                  </template>
                </ShowHideColumnsDialog>
              </template>

              <template v-slot:end_btns>
              </template>
              
            </table-list-toolbar>
          </v-card-title>

          <!-- Modo Mobile -->
          <v-card-title class="pa-0" v-if="is_mobile">
            <table-list-toolbar
              customClass="rounded-top card-title-mobile-mode"              
              :title="title"
              :actions="getActions"
              :groups="documentListActionGroups"
              :loading="loadingAction"
              :disabled="selected.length==0"
              :show_actions="(!this.permission.is_readonly || show_actions_ro()) && !is_mobile"
              @job-done="jobDone"
              @selected-action="selectedAction"
              :job_state="downloadJobState"
            > 
              <template v-slot:right_title_btn>
                <!-- v-if="permission.can_write" -->
                <v-btn
                  v-if="!permission.general.is_customer_consult"
                  @click="$router.push({ name: 'document-loader', params: { companydb_id: currentCompany.id } });"	
                  color="primary_blue"
                  class="white--text ml-5 upload-invoices"
                  :small='isMobile'
                >
                  <v-icon left color="white" class="material-symbols-outlined" small>upload_file</v-icon>
                  Subir Facturas
                </v-btn>
              </template>
              <template v-slot:initial_btns>
                <v-tooltip
                  v-if="!permission.is_readonly && !got_feature('feature_hide_invoices') && (permission.general.can_admin || permission.is_employee) && got_feature('feature_move_thirds_to_accounting')"
                  top
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      name="proveedores"
                      color="primary"
                      icon
                      @click="$router.push({ name: 'supplier-list', params: { companydb_id: currentCompany.id } })"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <AppIcon
                        src="/navigation/suppliers_v2.svg"
                        :size="32"
                        :colorMap="{ '663399': 'primary', '66359B': 'primary' }"
                      />
                    </v-btn>
                  </template>
                  <span>{{ $t('App.suppliers') }}</span>
                </v-tooltip>

                <v-tooltip
                  v-if="!permission.is_readonly && !got_feature('feature_hide_out_invoice') && !got_feature('feature_hide_invoices') && (permission.general.can_admin || permission.is_employee) && got_feature('feature_move_thirds_to_accounting')"
                  top
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      name="clientes"
                      color="primary"
                      icon
                      @click="$router.push({ name: 'customer-list', params: { companydb_id: currentCompany.id } })"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <AppIcon
                        src="/navigation/clients_v2.svg"
                        :size="32"
                        :colorMap="{ '663399': 'primary', '66359B': 'primary' }"
                      />
                    </v-btn>
                  </template>
                  <span>{{ $t('App.customers') }}</span>
                </v-tooltip>

                <v-btn name="refrescar" color="primary" icon @click="refreshData()" :loading="loading">
                  <AppIcon
                    :src="require('@/assets/documents_refresh.svg')"
                    :size="32"
                    :colorMap="{ '66359B': 'primary' }"
                  />
                </v-btn>
                <div>
                  <v-tooltip v-if="userData.available_features['feature_miniatura_ampliada'] && preview_docs && permission.can_write && !is_mobile" top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn class="btn-minus-plus" @click="embedPdfSize('auto','100px')" :color="preview_docs?'secondary':'primary'" icon v-bind="attrs" v-on="on">
                        <AppIcon
                          :src="require('@/assets/zoom_out.svg')"
                          :size="16"
                          :colorMap="{ '66359B': 'primary' }"
                        />
                      </v-btn>
                    </template>
                    <span v-if="preview_docs">Disminuir miniatura</span>
                  </v-tooltip>
                </div>
                <div>
                  <v-tooltip v-if="permission.can_write && !is_mobile" top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn @click="preview_docs = !preview_docs; embedPdfSize(300,'auto')" icon v-bind="attrs" v-on="on">
                          <AppIcon
                            :src="preview_docs ? require('@/assets/preview_doc_active.svg') : require('@/assets/preview_doc.svg')"
                            :size="32"
                            :colorMap="{ '66359B': 'primary' }"
                          />
                      </v-btn>
                    </template>
                    <span v-if="preview_docs">Ocultar previsualización</span>
                    <span v-else>Previsualizar documentos</span>
                  </v-tooltip>
                </div>
                <div>
                  <v-tooltip v-if="userData.available_features['feature_miniatura_ampliada'] && preview_docs && permission.can_write && !is_mobile" top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn class="btn-minus-plus" @click="embedPdfSize(450,600)" :color="preview_docs?'secondary':'primary'" icon v-bind="attrs" v-on="on">
                        <AppIcon
                          :src="require('@/assets/zoom_in.svg')"
                          :size="16"
                          :colorMap="{ '66359B': 'primary' }"
                        />
                      </v-btn>
                    </template>
                    <span v-if="preview_docs">Ampliar miniatura</span>
                  </v-tooltip>
                </div>
                <ShowDownloadInvoicesFilesDialog 
                    v-if="got_feature('feature_cloud_documents')"
                    :currentCompany_id="currentCompany.id"
                > 
                  
                </ShowDownloadInvoicesFilesDialog>
                
                <ShowHideColumnsDialog
                    v-if="!permission.is_readonly && got_feature('feature_config_table_columns')"
                    :showHideDialog="columnConfigDialog"
                    :key="columnConfigDialog"
                    :companyId="currentCompany.id"
                    settingCode="document_list_headers"
                    @restored="onColumnsRestored"
                  >
                  <template v-slot:actions>
                    <copy-settings
                            @copy-settings="copySettings"
                            :cdb_id="currentCompany.id"
                            code="document_list_headers"
                            :copying="copying"
                            v-if="userData.available_features['feature_copy_config_from_cdb']"
                    ></copy-settings>
                  </template>
                </ShowHideColumnsDialog>
              </template>
              <template v-slot:end_btns>
              </template>
            </table-list-toolbar>
          </v-card-title>

          <app-modal-prompt 
            v-model="dialogSimulation"
            @cancel="noSimulateItem()"
            @confirm="simulateItem()"
            :is-confirm-button-disabled="!companySimulate"
          >
            <template #title>
              Simular documentos
            </template>
              <app-modal-row>
                <app-modal-col cols="12">
                  <app-autocomplete
                    autocomplete="off"
                    label="Empresa"
                    v-model="companySimulate"
                    :items="get_companydbs"
                    item-text="name"
                    return-object
                  />
                </app-modal-col>
                <app-modal-col cols="12">
                  <app-select
                    autocomplete="off"
                    label="Etiquetas"
                    v-model="tagsSimulate"
                    :items="doc_filters_tags.values"
                    item-text="name"
                    item-value="value"
                    :multiple="true"
                    clearable
                  />
                </app-modal-col>
                <app-modal-col cols="12">
                  <app-select
                    v-model="accounting_date_config"
                    label="Fecha contable"
                    item-value="id"
                    item-text="text"
                    :items="ACCOUNTING_DATE_OPTIONS"
                  />
                </app-modal-col>
                <app-modal-col cols="12">
                  <app-text-field v-if="accounting_date_config=='configurated'"
                    :error="invalid_default_accounting_date"
                    label="Fecha (dd/mm/YYYY)" v-model="default_accounting_date"
                  />
                </app-modal-col>
              </app-modal-row>  
          </app-modal-prompt>

          <app-modal-prompt
            v-model="dialogCopy"
            :is-confirm-button-disabled="!companyChangeCompany"
            persistent
            @cancel="closeCopyDialog()"
            @confirm="copyDocsToOtherCDB()"
          >
            <template #title>
              {{ replicateConta ? 'Replicar' : 'Copiar' }} documentos a otra empresa
            </template>
            <app-modal-row>
              <p>
                Esta acción consume saldo por documento clonado.
              </p>
            </app-modal-row>
            <app-modal-row>
              <app-modal-col cols="12">
                <app-autocomplete
                  autocomplete="off"
                  label="Empresa"
                  v-model="companyChangeCompany"
                  item-text="name"
                  return-object
                  hide-details
                  :items="get_companydbs"
                  @change="getCompanyActivityList"
                ></app-autocomplete>
              </app-modal-col>
            </app-modal-row>
          </app-modal-prompt>

          <app-modal-prompt
            v-model="dialogChangeCompany"
            :is-confirm-button-disabled="!companyChangeCompany"
            persistent
            @cancel="noChangeCompanyItem()"
            @confirm="changeCompanyItem()"
          >
            <template #title>
              Modificación masiva de empresas
            </template>
            <app-modal-row>
              <app-modal-col cols="12">
                <app-autocomplete
                  autocomplete="off"
                  label="Empresa"
                  v-model="companyChangeCompany"
                  item-text="name"
                  return-object
                  hide-details
                  :items="get_companydbs"
                  @change="getCompanyActivityList"
                ></app-autocomplete>
              </app-modal-col>
            </app-modal-row>
            <app-modal-row v-if="showActivityField(companyChangeCompany, 'actividad')">
              <app-modal-col cols="12" class="mt-5">
                <app-select
                  v-if="listActividadChangeCompany.length > 0"
                  label="Actividad"
                  v-model="actividadChangeCompany"
                  :items="listActividadChangeCompany"
                  item-value="code" item-text="name"
                  :clearable="true"
                />
                <app-text-field
                  v-else
                  kind="number"
                  label="Actividad"
                  v-model="actividadChangeCompany"
                ></app-text-field>
              </app-modal-col>
            </app-modal-row>
          </app-modal-prompt>

          <app-modal-prompt
            v-model="dialogAddTags"
            @cancel="noAddTagsItem()"
            @confirm="addTagsItem()"
            :is-confirm-button-disabled="tagsAddTags.length==0"
            persistent
          >
              <template #title>
                Modificación masiva de etiquetas
              </template>
              <app-modal-row>
                <app-modal-col cols="12">
                  <app-select
                    v-model="tagsAddTags"
                    multiple
                    clearable
                    autocomplete="off"
                    label="Etiquetas"
                    item-value="value"
                    item-text="name"
                    :items="doc_filters_tags.values"
                  />
                </app-modal-col>
              </app-modal-row>
          </app-modal-prompt>

          <app-modal-prompt
            v-model="dialogTraining"
            @cancel="noTrainingItem()"
            @confirm="trainingItem()"
            persistent
          >
            <template #title>
              Copia masiva para training
            </template>
            <app-modal-row>
              <app-modal-col cols="12">
                <app-select
                  v-model="tagsTraining"
                  multiple
                  clearable
                  autocomplete="off"
                  label="Etiquetas"
                  item-text="name"
                  item-value="value"
                  :items="doc_filters_tags.values"
                />
              </app-modal-col>
            </app-modal-row>
          </app-modal-prompt>

          <app-modal-prompt
            v-model="dialogChangeThird"
            persistent
            :width="525"
            @cancel="noChangeThirdItem()"
            @confirm="changeThirdItem()"
          >
            <template #title>
              Asignación masiva de terceros
            </template>
            <app-modal-row>
              <app-modal-col cols="12">
                <app-autocomplete
                  outlined
                  autocomplete="off"
                  v-model="changeThirdValues.third_kind"
                  label="Tipo"
                  item-value="id"
                  item-text="name"
                  :items="itemsTypeChangeThird"
                  class="pt-0"
                  @change="onChangeKingChangeThirdDialog()"
                />
              </app-modal-col>
            </app-modal-row>
            <app-modal-row>
                <app-modal-col cols="12" v-show="changeThirdValues.third_kind=='supplier'">
                  <app-autocomplete-with-api
                    outlined
                    v-if="got_feature('feature_search_thirds_by_api')"
                    label="Proveedor (solo aplica a documentos de proveedores)"
                    v-model="changeThirdValues.supplierdb"
                    :starting_items="get_suppliers"
                    :url="'get_all_suppliers/?companydb_id=' + currentCompany.id"
                    item_text="name"
                    item_value="id"
                    item_search_field="selector_text"
                    :return_object="false"
                    class="pt-0"
                    :clearable="true"
                  />
                  <app-autocomplete
                    outlined
                    v-else
                    autocomplete="off"
                    v-model="changeThirdValues.supplierdb"
                    label="Proveedor (solo aplica a documentos de proveedores)"
                    item-value="id"
                    item-text="name"
                    :items="get_suppliers"
                    class="pt-0"
                  />
                </app-modal-col>
                <app-modal-col cols="12" v-show="changeThirdValues.third_kind=='customer'">
                  <app-autocomplete-with-api
                    outlined
                    v-if="got_feature('feature_search_thirds_by_api')"
                    label="Cliente (solo aplica a documentos de clientes)"
                    v-model="changeThirdValues.customerdb"
                    :starting_items="get_customers"
                    :url="'get_all_customers/?companydb_id=' + currentCompany.id"
                    item_text="name"
                    item_value="id"
                    item_search_field="selector_text"
                    :return_object="false"
                  />
                  <app-autocomplete
                    outlined
                    v-else
                    autocomplete="off"
                    v-model="changeThirdValues.customerdb"
                    label="Cliente (solo aplica a documentos de clientes)"
                    item-value="id"
                    item-text="name"
                    :items="get_customers"
                    class="pt-0"
                  />
                </app-modal-col>
              </app-modal-row>
              <app-modal-row>
                <app-modal-col cols="12">
                  <v-checkbox
                    v-model="changeThirdValues.apply_third_params"
                    :hide-details="true"
                    class="pa-0"
                    label="Aplicar parámetros definidos en el tercero a los documentos"
                    :disabled="(changeThirdValues.third_kind=='supplier' && !changeThirdValues.supplierdb) || (changeThirdValues.third_kind=='customer' && !changeThirdValues.customerdb)"
                  ></v-checkbox>
                </app-modal-col>
              </app-modal-row>
          </app-modal-prompt>

          <app-modal-prompt
            v-model="dialogEntryNumberCSV"
            persistent
            :width="525"
            @cancel="noEntryNumberCSV()"
            @confirm="entryNumberCSV()"
          >
            <template #title>
              Asignar número de apunte
            </template>
            <v-form ref="entryNumberDialogForm">
              <app-modal-row>
                <app-modal-col cols="12">
                  <app-text-field
                    kind="number"
                    label="Último número factura contabilizada"
                    v-model="last_entry_number_csv"
                    :rules="[validationRules.required, validationRules.number]"
                  ></app-text-field>
                </app-modal-col>
              </app-modal-row>
            </v-form>
          </app-modal-prompt>

          <app-modal-prompt
            v-model="dialogMigrateDoneToOtherCompany"
            :is-confirm-button-disabled="!migrateDoneSelectedCompany || migrateSameCompanySelected"
            persistent
            :width="575"
            @cancel="cancelMigrateDoneToOtherCompany()"
            @confirm="confirmMigrateDoneToOtherCompany()"
          >
            <template #title>
              Migrar movimientos contabilizados a otra empresa
            </template>
            <app-modal-row>
              <app-modal-col cols="12">
                <SelectorEmpresa
                  :value="migrateDoneSelectedCompany"
                  :items="get_companydbs"
                  :readonly="false"
                  :return_obj="true"
                  @gotInput="migrateDoneSelectedCompany = $event"
                />
              </app-modal-col>
            </app-modal-row>
            <div style="position: relative; height: 32px;">
              <div
                v-if="migrateSameCompanySelected"
                class="red--text text-caption mt-2 ml-1"
                style="position: absolute; top: 0; left: 0;"
              >
                * Seleccione una empresa distinta a la actual
              </div>
            </div>
          </app-modal-prompt>

          <MassiveChangesPopUp
            v-if="dialogMassiveChanges"
            :dialog="dialogMassiveChanges"
            :disabled="disableMassiveChanges()"
            :loading_massive_changes="loading_massive_changes"
            :buttons-on-top="true"
            @close-popup="cancelMassiveChanges()"
            @save-massive-changes="doMassiveChanges()"
          >
            <template v-slot:inputs>
              <app-modal-row >
                <app-modal-col>
                  <p class="black--text font-weight-light text-center massive-info mb-6" >
                    Seleccione el campo sobre el que quiere realizar el cambio masivo marcando el <v-checkbox hide-details class="ma-0 pa-0 check-info" readonly style="display: inline-block;"/> y seleccione o deje en blanco el valor que desee que tengan dichas facturas según el cambio a realizar.
                  </p>
                </app-modal-col>
              </app-modal-row>
              <app-modal-row>
                <app-modal-col cols="6">
                  <app-modal-row>
                    <app-modal-col cols="1">
                      <v-checkbox
                        v-model="isEnabled.kind"
                        :hide-details="true"
                        class="pa-0"
                      ></v-checkbox>
                    </app-modal-col>
                    <app-modal-col cols="10">
                      <app-select
                        outlined
                        v-model="massiveUpdateValues.kind"
                        label="Tipo de documento"
                        item-value="id"
                        item-text="text"
                        :items="availableDocs"
                        :disabled="!isEnabled.kind"
                        class="pt-0"
                      />
                    </app-modal-col>
                    <app-modal-col cols="1"></app-modal-col>
                  </app-modal-row>
                </app-modal-col>

              </app-modal-row>

              <app-modal-row>
                <app-modal-col cols="6">
                  <app-modal-row>
                    <app-modal-col cols="1">
                      <v-checkbox
                        v-model="isEnabled.invoice_date"
                        :hide-details="true"
                        class="pa-0"
                      ></v-checkbox>
                    </app-modal-col>
                    <app-modal-col cols="10">
                      <app-doc-text-field
                        kind="date"
                        v-model="massiveUpdateValues.invoice_date"
                        label="Fecha Factura (DD/MM/YYYY)"
                        :required="isEnabled.invoice_date"
                        :disabled="!isEnabled.invoice_date"
                        class="pt-0"
                      />
                    </app-modal-col>
                    <app-modal-col cols="1"></app-modal-col>
                  </app-modal-row>
                </app-modal-col>
                <app-modal-col cols="6">
                  <app-modal-row>
                    <app-modal-col cols="1"></app-modal-col>
                    <app-modal-col cols="1">
                      <v-checkbox v-model="isEnabled.due_date" class="pa-0" />
                    </app-modal-col>
                    <app-modal-col cols="10">
                      <app-doc-text-field
                        v-model="massiveUpdateValues.due_date"
                        class="pt-0"
                        kind="date"
                        label="Fecha de Vencimiento (DD/MM/YYYY)"
                        :disabled="!isEnabled.due_date" 
                        :required="isEnabled.due_date"
                      />
                    </app-modal-col>
                  </app-modal-row>
                </app-modal-col>
              </app-modal-row>

              <app-modal-row>
                <app-modal-col cols="6">
                  <app-modal-row>
                    <app-modal-col cols="1">
                      <v-checkbox
                        v-model="isEnabled.accounting_date_config"
                        :hide-details="true"
                        class="pa-0"
                      ></v-checkbox>
                    </app-modal-col>
                    <app-modal-col cols="10">
                      <!-- <doc-text-field
                        label="Fecha factura"
                        v-model="massiveUpdateValues.metadata__invoice_date"
                        :disabled="!isEnabled.metadata__invoice_date"
                      ></doc-text-field> -->
                      <app-select
                        outlined
                        :disabled="!isEnabled.accounting_date_config"
                        v-model="massiveUpdateValues.accounting_date_config"
                        label="Fecha contable"
                        item-value="id"
                        item-text="text"
                        :items="ACCOUNTING_DATE_OPTIONS"
                        class="pt-0"
                      />
                    </app-modal-col>
                    <app-modal-col cols="1"></app-modal-col>
                  </app-modal-row>
                </app-modal-col>
                <app-modal-col cols="6" v-if="isEnabled.accounting_date_config && massiveUpdateValues.accounting_date_config=='configurated'">
                  <app-modal-row>
                    <app-modal-col cols="2"></app-modal-col>
                    <app-modal-col cols="10">
                      <app-doc-text-field
                        kind="date"
                        v-model="massiveUpdateValues.default_accounting_date"
                        label="Fecha contabilización (DD/MM/YYYY)"
                        :required="isEnabled.accounting_date_config && massiveUpdateValues.accounting_date_config=='configurated'"
                      />
                    </app-modal-col>
                  </app-modal-row>
                </app-modal-col>
              </app-modal-row>
              <app-modal-row v-if="got_feature('feature_fecha_registro') && currentCompany && currentCompany.enable_fecha_sii">
                <app-modal-col cols="6">
                  <app-modal-row>
                    <app-modal-col cols="1">
                      <v-checkbox
                        v-model="isEnabled.registro_date_config"
                        :hide-details="true"
                        class="pa-0"
                      ></v-checkbox>
                    </app-modal-col>
                    <app-modal-col cols="10">
                      <app-select
                        outlined
                        :disabled="!isEnabled.registro_date_config"
                        v-model="massiveUpdateValues.registro_date_config"
                        label="Fecha SII"
                        item-value="id"
                        item-text="text"
                        :items="REGISTRO_DATE_OPTIONS"
                        class="pt-0"
                      />
                    </app-modal-col>
                    <app-modal-col cols="1"></app-modal-col>
                  </app-modal-row>
                </app-modal-col>
                <app-modal-col cols="6" v-if="isEnabled.registro_date_config && massiveUpdateValues.registro_date_config=='configurated'">
                  <app-modal-row>
                    <app-modal-col cols="2"></app-modal-col>
                    <app-modal-col cols="10">
                      <app-doc-text-field
                        kind="date"
                        v-model="massiveUpdateValues.default_registro_date"
                        label="Fecha registro (DD/MM/YYYY)"
                        :required="isEnabled.registro_date_config && massiveUpdateValues.registro_date_config=='configurated'"
                      />
                    </app-modal-col>
                  </app-modal-row>
                </app-modal-col>
              </app-modal-row>
              <app-modal-row >
                <app-modal-col 
                  cols="6" 
                  v-if="(showActivityField(currentCompany, 'actividad') || (showActivityField(currentCompany, 'actividad_str')) && got_feature('feature_actividad_str_field')) && currentCompany && !currentCompany.hide_activities_master"
                >
                  <app-modal-row  v-if="showActivityField(currentCompany, 'actividad')">
                    <app-modal-col cols="1">
                      <v-checkbox
                        v-model="isEnabled.actividad"
                        :hide-details="true"
                        class="pa-0"
                      ></v-checkbox>
                    </app-modal-col>
                    <app-modal-col cols="10" >
                      <app-autocomplete
                        outlined
                        v-if="got_feature('feature_actividad_selector') && activities.length > 0"
                        label="Actividad"
                        v-model="massiveUpdateValues.actividad"
                        :items="activities"
                        class="pa-0"
                        item-value="code" item-text="name"
                        :clearable="true"
                        :disabled="!isEnabled.actividad"
                      />
                      <app-doc-text-field
                        v-else
                        label="Actividad"
                        v-model="massiveUpdateValues.actividad"
                        :disabled="!isEnabled.actividad"
                      />
                    </app-modal-col>
                    <app-modal-col cols="1"></app-modal-col>
                  </app-modal-row>
                  <app-modal-row v-else-if="got_feature('feature_actividad_str_field') && showActivityField(currentCompany, 'actividad_str')">
                    <app-modal-col cols="1">
                      <v-checkbox
                        v-model="isEnabled.actividad_str"
                        :hide-details="true"
                        class="pa-0"
                      ></v-checkbox>
                    </app-modal-col>
                    <app-modal-col cols="10">
                      <app-autocomplete
                        outlined
                        v-if="got_feature('feature_actividad_selector') && activities.length > 0"
                        label="Actividad"
                        v-model="massiveUpdateValues.actividad_str"
                        :items="activities"
                        class="pa-0"
                        item-value="code" item-text="name"
                        :clearable="true"
                        :disabled="!isEnabled.actividad_str"
                      />
                      <app-doc-text-field v-else
                        label="Actividad"
                        v-model="massiveUpdateValues.actividad_str"
                        :disabled="!isEnabled.actividad_str"
                      />
                    </app-modal-col>
                  </app-modal-row>
                </app-modal-col>
                <app-modal-col 
                  cols="6"
                  v-if="showProjectFields()" 
                >
                  <app-modal-row>
                    <app-modal-col cols="1">
                      <v-checkbox
                        v-model="isEnabled.project"
                        :hide-details="true"
                        class="pa-0"
                      ></v-checkbox>
                    </app-modal-col>
                    <app-modal-col cols="10">
                      <app-autocomplete
                        outlined
                        label="Proyecto"
                        v-model="massiveUpdateValues.project"
                        :items="projects"
                        class="pa-0"
                        item-value="id" item-text="name"
                        :clearable="true"
                        :disabled="!isEnabled.project"
                      />

                    </app-modal-col>
                  </app-modal-row>
                </app-modal-col>
              </app-modal-row>
              <app-modal-row>
                <app-modal-col 
                  cols="6" 
                  v-if="showChannelFields()"
                >
                  <app-modal-row>
                    <app-modal-col cols="1">
                      <v-checkbox
                        v-model="isEnabled.channel"
                        :hide-details="true"
                        class="pa-0"
                      ></v-checkbox>
                    </app-modal-col>
                    <app-modal-col cols="10">
                      <app-autocomplete
                        outlined
                        label="Canal"
                        v-model="massiveUpdateValues.channel"
                        :items="channels"
                        class="pa-0"
                        item-value="channel_id" 
                        item-text="name"
                        :clearable="true"
                        :disabled="!isEnabled.channel"
                      />
                    </app-modal-col>
                    <!-- <app-modal-col cols="1" /> -->
                  </app-modal-row>
                </app-modal-col>
                <app-modal-col 
                  cols="6"
                  v-if="showSectionFields()" 
                >
                  <app-modal-row>
                    <app-modal-col cols="1">
                      <v-checkbox
                        v-model="isEnabled.section"
                        :hide-details="true"
                        class="pa-0"
                      ></v-checkbox>
                    </app-modal-col>
                    <app-modal-col cols="10">
                      <app-autocomplete
                        outlined
                        label="Sección"
                        v-model="massiveUpdateValues.section"
                        :items="sections"
                        class="pa-0"
                        item-value="section_id" 
                        item-text="name"
                        :clearable="true"
                        :disabled="!isEnabled.section"
                      />
                    </app-modal-col>
                  </app-modal-row>
                </app-modal-col>
              </app-modal-row>
              <app-modal-row>
                <app-modal-col 
                  cols="6"
                  v-if="showDelegationFields()" 
                >
                  <app-modal-row>
                    <app-modal-col cols="1">
                      <v-checkbox
                        v-model="isEnabled.delegation"
                        :hide-details="true"
                        class="pa-0"
                      ></v-checkbox>
                    </app-modal-col>
                    <app-modal-col cols="10">
                      <app-autocomplete
                        outlined
                        label="Delegación"
                        v-model="massiveUpdateValues.delegation"
                        :items="delegations"
                        class="pa-0"
                        item-value="delegation_id" 
                        item-text="name"
                        :clearable="true"
                        :disabled="!isEnabled.delegation"
                      />
                    </app-modal-col>
                  </app-modal-row>
                </app-modal-col>
                <app-modal-col 
                  cols="6"
                  v-if="showDepartmentFields()" 
                >
                  <app-modal-row>
                    <app-modal-col cols="1">
                      <v-checkbox
                        v-model="isEnabled.department"
                        :hide-details="true"
                        class="pa-0"
                      ></v-checkbox>
                    </app-modal-col>
                    <app-modal-col cols="10">
                      <app-autocomplete
                        outlined
                        label="Departamento"
                        v-model="massiveUpdateValues.department"
                        :items="departments"
                        class="pa-0"
                        item-value="department_id" 
                        item-text="name"
                        :clearable="true"
                        :disabled="!isEnabled.department"
                      />
                    </app-modal-col>
                  </app-modal-row>
                </app-modal-col>
              </app-modal-row>
              <app-modal-row v-if="got_feature('feature_serie_in_docs')">
                <app-modal-col cols="6" v-if="got_feature('feature_serie_in_docs')">
                  <app-modal-row>
                    <app-modal-col cols="1">
                      <v-checkbox
                        v-model="isEnabled.serie"
                        :hide-details="true"
                        class="pa-0"
                      ></v-checkbox>
                    </app-modal-col>
                    <app-modal-col cols="10">
                      <app-doc-text-field
                        label="Serie"
                        v-model="massiveUpdateValues.serie"
                        :disabled="!isEnabled.serie"
                      />
                    </app-modal-col>
                    <app-modal-col cols="1"></app-modal-col>
                  </app-modal-row>
                </app-modal-col>
              </app-modal-row> 
              <app-modal-row 
                v-if="(got_feature('feature_document_number_prefix') || got_feature('feature_document_number')) && !got_feature('feature_generar_num_documento_csv_facturas')"
              >
                <app-modal-col cols="6" v-if="got_feature('feature_document_number_prefix')">
                  <app-modal-row>
                    <app-modal-col cols="1">
                      <v-checkbox
                        v-model="isEnabled.doc_number_prefix"
                        :hide-details="true"
                        class="pa-0"
                      ></v-checkbox>
                    </app-modal-col>
                    
                    <app-modal-col cols="10">
                      <app-doc-text-field
                        kind="text"
                        label="Prefijo"
                        v-model="massiveUpdateValues.doc_number_prefix"
                        :disabled="!isEnabled.doc_number_prefix"
                      />
                    </app-modal-col>
                     <app-modal-col cols="1" />
                  </app-modal-row>
                </app-modal-col>
                <app-modal-col cols="6" v-if="got_feature('feature_document_number') && !got_feature('feature_generar_num_documento_csv_facturas')">
                  <app-modal-row>
                    <app-modal-col v-if="got_feature('feature_document_number_prefix')" cols="1"></app-modal-col>
                    <app-modal-col cols="1">
                      <v-checkbox
                        v-model="isEnabled.doc_number"
                        :hide-details="true"
                        class="pa-0"
                      ></v-checkbox>
                    </app-modal-col>
                    
                    <app-modal-col cols="10">
                      <app-doc-text-field
                        kind="number"
                        label="Núm. documento mínimo (se numeran de forma ascendente)"
                        v-model="massiveUpdateValues.doc_number"
                        :disabled="!isEnabled.doc_number"
                      />
                    </app-modal-col>
                     <app-modal-col cols="1" />
                  </app-modal-row>
                </app-modal-col>
              </app-modal-row>
              <v-divider />

              <app-modal-row class="section-tax-options">

                <app-modal-col cols="3">
                  <v-checkbox
                    v-model="isEnabled.fiscal"
                    :hide-details="true"
                    class="pa-0"
                    label="Posición fiscal"
                  ></v-checkbox>
                  <v-radio-group v-model="selectedFiscal" @change="resetFiscalOption" :key="selectedFiscal" :disabled="!isEnabled.fiscal">
                    <div @click="toggleFiscal">
                      <v-radio value="inversion_sujeto_pasivo_iva" label="Inversión sujeto pasivo IVA" />
                    </div>
                    <div @click="toggleFiscal">
                      <v-radio value="inversion_sujeto_pasivo_igic" label="Inversión sujeto pasivo IGIC" />
                    </div>
                    <div @click="toggleFiscal">
                      <v-radio value="intracomunitario" label="Intracomunitario" />
                    </div>
                    <!-- <div @click="toggleFiscal">
                      <v-radio value="extracomunitario"  label="Extracomunitario" />
                    </div> -->
                    <div @click="toggleFiscal" v-if="userData.available_features['feature_no_sujeta']">
                      <v-radio value="no_sujeta"  label="No sujeta" />
                    </div>
                    <div @click="toggleFiscal" v-if="got_feature('feature_supplier_comerciante_minorista') && currentCompany.tax_type == 'igic'">
                      <v-radio value="is_comerciante_minorista" label="Comerciante Minorista" />
                    </div>
                  </v-radio-group>
                  <app-modal-col v-if="selectedFiscal && PROVIDER_SOMETHING_OPTIONS[selectedFiscal]">
                    <app-autocomplete
                      outlined
                      hide-details
                      v-model="selectedFiscalOption"
                      :disabled="!isEnabled.fiscal"
                      autocomplete="off"
                      :label="(selectedFiscal === 'extracomunitario' ? 'Exportaciones' : 'Porcentaje') + ' (Solo aplica a documentos de proveedor)'"
                      :items="PROVIDER_SOMETHING_OPTIONS[selectedFiscal]"
                    />
                    <app-autocomplete
                      outlined
                      hide-details
                      class="mt-5"
                      v-if="(selectedFiscal == 'intracomunitario' && userData.available_features['feature_intra_type']) || (selectedFiscal == 'extracomunitario' && (userData.available_features['feature_extra_type'] || userData.available_features['feature_extracomunitario_type']))"
                      v-model="selectedFiscalOption2"
                      :disabled="!isEnabled.fiscal"
                      autocomplete="off"
                      label="Tipo"
                      :items="PROVIDER_SOMETHING_OPTIONS2[selectedFiscal]"
                    />
                  </app-modal-col>
                </app-modal-col>

                <v-divider inset vertical />
                <app-modal-col cols="3">
                  <app-modal-row class="d-flex align-center">
                    <app-modal-col cols="auto">
                      <v-checkbox
                        v-model="isEnabled.bien_inversion"
                        :hide-details="true"
                        :disabled="!userData.available_features['feature_bien_inversion']"
                        class="pa-0"
                      ></v-checkbox>
                    </app-modal-col>
                    <app-modal-col>
                      <v-radio-group class="pa-0" v-model="selectedInversion" :key="selectedInversion" hide-details>
                        <div @click="toggleInversion">
                          <v-radio 
                            label="Bienes de inversión" 
                            :disabled="!isEnabled.bien_inversion || !userData.available_features['feature_bien_inversion']"
                            :value="true"
                          />
                        </div>
                      </v-radio-group>
                    </app-modal-col>
                  </app-modal-row>
                  <app-modal-row class="d-flex align-center">

                    <app-modal-col cols="auto">
                      <v-checkbox
                        v-model="isEnabled.criterio_de_caja"
                        :hide-details="true"
                        :disabled="!got_feature('feature_criterio_de_caja')"
                        class="pa-0"
                      ></v-checkbox>
                    </app-modal-col>

                    <app-modal-col>
                      <v-radio-group class="pa-0" v-model="selectedCriterioCaja" :key="selectedCriterioCaja" hide-details>
                        <div @click="toggleCriterioCaja">
                          <v-radio 
                            label="Criterio de caja" 
                            :disabled="!isEnabled.criterio_de_caja || !got_feature('feature_criterio_de_caja')"
                            :value="true"
                          />
                        </div>
                      </v-radio-group>
                    </app-modal-col>

                  </app-modal-row>
                  
                </app-modal-col>

                <v-divider inset vertical />
                <app-modal-col cols="3">
                  <v-checkbox
                    v-model="isEnabled.deducibilidad"
                    :hide-details="true"
                    class="pa-0"
                    label="Deducibilidad"
                  ></v-checkbox>
                  <v-radio-group v-model="selectedIvaCheck" :key="selectedIvaCheck" :disabled="!isEnabled.deducibilidad">
                    <div @click="toggleIvaCheck">
                      <v-radio
                        value="iva_igic_no_deducible"
                        label="IVA/IGIC no deducible"
                      ></v-radio>
                    </div>
                    <div @click="toggleIvaCheck" v-if="userData.available_features['feature_gasto_iva_parcial']">
                      <v-radio
                        value="gasto_iva_parcial"
                        label="Gasto+IVA deducible parcialmente"
                      ></v-radio>
                    </div>
                    <div @click="toggleIvaCheck"  v-if="userData.available_features['feature_iva_deducible_parcialmente']">
                      <v-radio
                        value="iva_parcial"
                        label="IVA deducible parcialmente"
                      ></v-radio>
                    </div>
                    <div @click="toggleIvaCheck"  v-if="userData.available_features['feature_prorate'] && currentCompany.prorate">
                      <v-radio
                        value="prorate"
                        label="Prorrata"
                      ></v-radio>
                    </div>
                  </v-radio-group>
                  <v-checkbox
                    v-if="selectedIvaCheck=='iva_igic_no_deducible' && userData.available_features['feature_comerciante_minorista'] && currentCompany && currentCompany.companydb_type.params && ((!currentCompany.companydb_type.params.hasOwnProperty('hide')) || (currentCompany.companydb_type.params.hide && !currentCompany.companydb_type.params.hide.includes('comerciante_minorista')))"
                    :disabled="!isEnabled.deducibilidad"
                    label="Registrar en libro de facturas"
                    v-model="comerciante_minorista"
                  ></v-checkbox>
                  <app-doc-text-field
                    v-if="selectedIvaCheck=='gasto_iva_parcial' || selectedIvaCheck=='iva_parcial'"
                    kind="number"
                    label="Porcentaje"
                    v-model="gasto_iva_percent"
                    :disabled="!isEnabled.deducibilidad"
                    :error="gasto_iva_percent <= 0 || gasto_iva_percent >= 100"
                  />
                </app-modal-col>

                <app-modal-col cols="3">
                  <app-modal-row class="d-flex align-center">
                    <app-modal-col cols="auto">
                      <v-checkbox
                        v-model="isEnabled.apply_347"
                        :hide-details="true"
                        :disabled="!got_feature('feature_apply_347')"
                        class="pa-0"
                        label="Modelos informativos"
                      />
                    </app-modal-col>
                    <app-modal-col>
                      <v-checkbox
                        v-model="massiveUpdateValues.apply_347"
                        :disabled="!isEnabled.apply_347"
                        on-icon="mdi-radiobox-marked"
                        off-icon="mdi-radiobox-blank"
                        label="Aplicar Modelo 347"
                        hide-details
                        class="pa-0"
                      />
                    </app-modal-col>
                  </app-modal-row>
                </app-modal-col>

              </app-modal-row>

            </template>
          </MassiveChangesPopUp>

          <app-modal-prompt
            v-model="dialogMassiveRotation" 
            width="1000"
            :showConfirmBtn="false"
            persistent
            @cancel="() => { dialogMassiveRotation = false; loadingAction = false }"
          >
              <template #title>
                Rotación de documentos
              </template>
                <app-modal-row class="text-center">
                  <app-modal-col cols="12" sm="4" >
                    <app-btn color="primary" @click="doMassiveRotation(-90)">
                      Rotar 90º a la izquierda
                      <!-- <v-icon style="transform: rotateY(180deg);">mdi-format-rotate-90</v-icon> -->
                      <v-icon right v-once>mdi-file-document mdi-rotate-270</v-icon>
                    </app-btn>
                  </app-modal-col>
                  <app-modal-col cols="12" sm="4" :class="$vuetify.breakpoint.xs ? 'py-5' : ''" >
                    <app-btn color="primary" @click="doMassiveRotation(180)">
                      Rotar 180º
                      <v-icon right v-once>mdi-file-document mdi-rotate-180</v-icon>
                    </app-btn>
                  </app-modal-col>
                  <app-modal-col cols="12" sm="4" >
                    <app-btn color="primary" @click="doMassiveRotation(90)">
                      Rotar 90º a la derecha
                      <!-- <v-icon>mdi-format-rotate-90</v-icon> -->
                      <v-icon right v-once>mdi-file-document mdi-rotate-90</v-icon>
                    </app-btn>
                  </app-modal-col>
                </app-modal-row>
          </app-modal-prompt>

          <app-modal-prompt 
            v-model="dialogMassiveCalculateBaseCuota"
            confirm-btn-text="Calcular"
            :is-confirm-button-disabled="!percentMassiveCalculateBaseCuota"
            :loading="loading_massive_changes"
            @cancel="cancelMassiveCalculateBaseCuota"
            @confirm="doMassiveCalculateBaseCuota" 
            persistent
          >
            <template #title>Calcular base y Cuota de forma masiva</template>
            <app-modal-container>
              <app-modal-row>
                <app-modal-col cols="12">
                  <app-autocomplete
                    v-model="percentMassiveCalculateBaseCuota"
                    hide-details
                    autocomplete="off"
                    label="Porcentaje"
                    class="autocomplete-input pa-0"
                    :items="percentMassiveCalculateBaseCuotaValues"
                  />
                </app-modal-col>
              </app-modal-row>
            </app-modal-container>
          </app-modal-prompt>

          <app-confirm-modal
              v-model="confirmDocsContabilizar"
              :text-msg="msgConfirmDocsContabilizar"
              :text-question="questionConfirmDocsContabilizar"
              :width="825"
          >
            <template v-slot:modal_buttons>
              <app-modal-col 
                cols="12" sm="4" 
                class="ma-0 pa-0 d-flex justify-start"
              >
                <app-btn 
                  large
                  :block="$vuetify.breakpoint.xs"
                  outlined
                  @click="cancelDocsContabilizarModal()"
                >
                  Cancelar Acción
                </app-btn>
              </app-modal-col>
              <app-modal-col 
                cols="12" sm="4" 
                class="ma-0 pa-0 d-flex"
              >
                <app-btn 
                  large
                  :block="$vuetify.breakpoint.xs"
                  :loading="loadingDocsContabilizarPteRev"
                  :disabled="loadingDocsContabilizarAll"
                  @click="confirmDocsContabilizarModal('solo_pte_revision')"
                >
                  Omitir Rev. Requerida
                </app-btn>
              </app-modal-col>
              <app-modal-col 
                cols="12" sm="4" 
                class="ma-0 pa-0 d-flex justify-end"
              >
                <app-btn 
                  large
                  :block="$vuetify.breakpoint.xs"
                  :loading="loadingDocsContabilizarAll"
                  :disabled="loadingDocsContabilizarPteRev"
                  @click="confirmDocsContabilizarModal('todos')"
                >
                  Contabilizar Todos
                </app-btn>
              </app-modal-col>
            </template>
          </app-confirm-modal>

          <app-confirm-modal
              v-model="confirmDocsDownloadCSV"
              :text-msg="msgConfirmDocsDownloadCSV"
              :text-question="questionConfirmDocsDownloadCSV"
              :width="825"
          >
            <template v-slot:modal_buttons>
              <app-modal-col 
                cols="12" sm="4" 
                class="ma-0 pa-0 d-flex justify-start"
              >
                <app-btn 
                  large
                  :block="$vuetify.breakpoint.xs"
                  outlined
                  @click="cancelDocsDownloadCSVModal()"
                >
                  Cancelar Acción
                </app-btn>
              </app-modal-col>
              <app-modal-col 
                cols="12" sm="4" 
                class="ma-0 pa-0 d-flex"
              >
                <app-btn 
                  large
                  :block="$vuetify.breakpoint.xs"
                  :loading="loadingDocsDownloadCSVNoRevReq"
                  :disabled="loadingDocsDownloadCSVAll"
                  @click="confirmDocsDownloadCSVModal('not_rev_req')"
                >
                  Omitir Rev. Requerida
                </app-btn>
              </app-modal-col>
              <app-modal-col 
                cols="12" sm="4" 
                class="ma-0 pa-0 d-flex justify-end"
              >
                <app-btn 
                  large
                  :block="$vuetify.breakpoint.xs"
                  :loading="loadingDocsDownloadCSVAll"
                  :disabled="loadingDocsDownloadCSVNoRevReq"
                  @click="confirmDocsDownloadCSVModal('todos')"
                >
                  Descargar Todos
                </app-btn>
              </app-modal-col>
            </template>
          </app-confirm-modal>

          <app-confirm-modal
              v-model="markAsPendingReviewDialog"
              :text-msg="markAsPendingReviewMsg"
              @confirm="confirmMarkAsPendingReview()"
              @cancel="noMarkAsPendingReview()"
          >
          </app-confirm-modal>

          <app-confirm-modal
              v-model="bckDocPendingReviewDialog"
              :text-msg="bckDocPendingReviewMsg"
              @confirm="confirmBckDocPendingReview()"
              @cancel="noBckDocPendingReview()"
          >
          </app-confirm-modal>

          <app-confirm-modal
              v-model="markAsErrorAccountConnectorDialog"
              :text-msg="markAsErrorAccountConnectorMsg"
              @confirm="confirmMarkAsErrorAccountConnector()"
              @cancel="noMarkAsErrorAccountConnector()"
          >
          </app-confirm-modal>

          <!-- Card Filters Mobile -->
          <template v-if="isMobile">
            <div>
              
              <v-btn
                v-if="!showFilters"
                  fab
                  color="primary"
                  class="elevation-10"
                  style="
                    position: fixed; 
                    top: 130px; 
                    left: 16px; 
                    width: 40px; 
                    height: 40px; 
                    min-width: 40px;"
                @click="showFilters = true"
              >
                <v-icon small>mdi-filter-variant</v-icon>
              </v-btn>

              <v-dialog v-model="showFilters" persistent max-width="400">
                <v-card>
                  <v-card-title class="subtitle-1 font-weight-bold d-flex justify-space-between align-center">
                    Filtros
                    <v-btn icon @click="showFilters = false">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-card-title>
                  <v-divider class="mb-4" />

                  <v-card-text>
                    <v-card
                      v-for="(filter, index) in currentMainFilters"
                      :key="index"
                      class="pa-3 mb-2 d-flex justify-space-between align-center"
                      :color="filter.values === selectedStateChip ? 'primary' : 'white'"
                      @click="selectChip(filter)"
                      rounded
                      elevation="1"
                    >
                      <div :class="filter.values === selectedStateChip ? 'white--text' : 'black--text'">
                        <strong>{{ filter.name }}</strong>
                      </div>
                      <v-chip
                        small
                        :color="filter.values === selectedStateChip ? 'white' : 'primary'"
                        :text-color="filter.values === selectedStateChip ? 'primary' : 'white'"
                      >
                        {{ filter.count }}
                      </v-chip>
                    </v-card>
                  </v-card-text>

                  <v-card-actions>
                    <v-btn
                      block
                      text
                      color="secondary"
                      class="mt-2"
                      @click="unselectChip"
                    >
                      Limpiar selección
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>

            </div>
          </template>

          <v-row>
            <!-- Column Filters Desktop -->
            <v-col v-if="! isMobile" cols="12" md="11">
              <v-row justify="center" class="d-flex justify-space-around" v-if="permission && (!permission.is_readonly || show_chips_readonly )">
                <v-col
                    cols="6"
                    sm="4"
                    :md="show_chip_pending_sync ? 'auto' : '2'"
                    v-for="(filter,index) in currentMainFilters"
                    :key="index"
                    class="text-center"
                >
                  <v-chip
                    :close="filter.values==selectedStateChip&&selectedStateChip!='all'"
                    close-icon="mdi-close-outline"
                    :color="filter.values==selectedStateChip?'primary':'gray'"
                    @click:close="unselectChip()"
                    @click="selectChip(filter)"
                    :name="filter.name"
                  >
                    <div class="chiptext">{{filter.name}}</div>
                    <v-avatar
                      right
                      width="auto !important"
                      style="border-radius: 16px; padding-right: 6px; padding-left: 6px"
                      :class="filter.values==selectedStateChip?'primary white':'white darken-4'"
                    >
                      {{filter.count}}
                    </v-avatar>
                  </v-chip>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="1" v-if="userData.available_features['feature_document_filter_bar']">
              <v-row justify="center" class="pt-2 pb-2 pr-10">
              <v-btn
                  fab
                  small
                  :style="{'background-color': showFilters ? 'var(--v-secondary-base)' : 'var(--v-primary-base)'}"
                  @click="showFilters = !showFilters"
              >
                <v-icon color="white">mdi-filter</v-icon>
              </v-btn>
              </v-row>
            </v-col>
            
            <v-col ref="filtersContainer" cols="12" v-if="userData.available_features['feature_document_filter_bar'] && showFilters" class="pa-0 ma-0" style="overflow-x: hidden;">
              <v-row class="pa-0 ma-0" no-gutters>
                <app-search-bar
                    :filters="enrichedDocumentListFiltersData2"
                    :conditions="getFiltersConditions"
                    :initial_filters="initialFiltersForSearchBar"
                    @updateObject="updateFilter"
                    @resetAllFilters="removeAllFilt"
                    :pin-state="true"
                    v-if="userData.available_features['feature_document_filter_bar']"
                />
              </v-row>
            </v-col>
            <v-col cols="1" v-if="!userData.available_features['feature_document_filter_bar']">
              <Browser v-if="currentFiltersLoaded" :filters="documentsListFilters" :searchFunc="generateFilters" :cleanFunc="cleanFilters" :fab="is_mobile">
                <template v-slot:inputs>
                  <v-row>
                    <v-col cols="12">
                      <div>
                        <v-autocomplete
                          v-if="userData.available_features['feature_filter_by_ejercicio']"
                          autocomplete="off"
                          :label="doc_filters_ejercicio.label"
                          v-model="doc_filters_ejercicio_value"
                          :items="currentCompany.links"
                          :item-text="getEjercicioItemText"
                          item-value="id"
                          clearable
                        >
                          <template slot="item" slot-scope="data">
                            {{ data.item.min_date.split('-')[0] }}
                          </template>
                        </v-autocomplete>
                        <v-text-field
                          autocomplete="off"
                          :label="doc_filters_id.label"
                          v-model="doc_filters_id_value"
                          v-on:keyup.enter="generateFilters"
                          type="number"
                        ></v-text-field>
                        <v-text-field
                          autocomplete="off"
                          :label="doc_filters_search__icontains.label"
                          v-model="doc_filters_search__icontains_value"
                          v-on:keyup.enter="generateFilters"
                        ></v-text-field>
                        <v-text-field
                          autocomplete="off"
                          :label="doc_filters_search__duplicate.label"
                          v-model="doc_filters_search__duplicate_value"
                          v-on:keyup.enter="generateFilters"
                        ></v-text-field>
                        <v-text-field
                          v-if="userData.available_features['feature_document_text_filter']"
                          autocomplete="off"
                          :label="doc_filters_document_text__icontains.label"
                          v-model="doc_filters_document_text__icontains_value"
                          v-on:keyup.enter="generateFilters"
                        ></v-text-field>

                        <v-text-field
                          v-if="docsContainValue('account_move_number')"
                          autocomplete="off"
                          :label="doc_filters_account_move_number__icontains.label"
                          v-model="doc_filters_account_move_number__icontains_value"
                          @keyup.enter="generateFilters"
                        />

                        <v-text-field
                          v-if="docsContainValue('entry_number')"
                          autocomplete="off"
                          :label="doc_filters_entry_number__icontains.label"
                          v-model="doc_filters_entry_number__icontains_value"
                          @keyup.enter="generateFilters"
                        />

                        <v-select
                          autocomplete="off"
                          v-if="doc_filters_tags.values && (userData.is_staff || (userData.hasOwnProperty('username') && session_information.hasOwnProperty('username') && (session_information.username != userData.username)))"
                          :label="doc_filters_tags.label"
                          v-model="doc_filters_tags_value"
                          :items="doc_filters_tags.values"
                          item-text="name"
                          item-value="value"
                          :multiple="doc_filters_tags.multiple"
                          clearable
                          v-on:keyup.enter="generateFilters"
                        ></v-select>
                        <v-text-field
                          v-if="userData.can_see_training_documents"
                          autocomplete="off"
                          :label="doc_filters_username__icontains.label"
                          v-model="doc_filters_username__icontains_value"
                          v-on:keyup.enter="generateFilters"
                        ></v-text-field>
                        <v-select
                          autocomplete="off"
                          :label="doc_filters_kind.label"
                          v-model="doc_filters_kind_value"
                          :items="doc_filters_kind.values"
                          item-text="name"
                          item-value="value"
                          :multiple="doc_filters_kind.multiple"
                          clearable
                          v-on:keyup.enter="generateFilters"
                        ></v-select>

                        <date-picker
                          v-if="userData.available_features.feature_can_see_doc_created_date"
                          aucomplete="off"
                          :label="doc_filters_created__gte.label"
                          v-model="doc_filters_created__gte_value"
                          @entered="generateFilters"
                        ></date-picker>
                        <date-picker
                          v-if="userData.available_features.feature_can_see_doc_created_date"
                          aucomplete="off"
                          :label="doc_filters_created__lte.label"
                          v-model="doc_filters_created__lte_value"
                          @entered="generateFilters"
                        ></date-picker>

                        <date-picker
                          aucomplete="off"
                          :label="doc_filters_accounting_date__gte.label"
                          v-model="doc_filters_accounting_date__gte_value"
                          @entered="generateFilters"
                        ></date-picker>
                        <date-picker
                          aucomplete="off"
                          :label="doc_filters_accounting_date__lte.label"
                          v-model="doc_filters_accounting_date__lte_value"
                          @entered="generateFilters"
                        ></date-picker>

                        <date-picker
                          v-if="metadataFiltersStates.includes(selectedStateChip)"
                          aucomplete="off"
                          :label="doc_filters_invoice_date__gte.label"
                          v-model="doc_filters_invoice_date__gte_value"
                          @entered="generateFilters"
                        ></date-picker>
                        <date-picker
                          v-if="metadataFiltersStates.includes(selectedStateChip)"
                          aucomplete="off"
                          :label="doc_filters_invoice_date__lte.label"
                          v-model="doc_filters_invoice_date__lte_value"
                          @entered="generateFilters"
                        ></date-picker>

                        <!-- <date-widget
                          autocomplete="off"
                          :label="doc_filters_metadata__invoice_date__gte.label"
                          v-model="doc_filters_metadata__invoice_date__gte_value"
                          v-on:keyup.enter="generateFilters"
                        />
                        <date-widget
                          autocomplete="off"
                          :label="doc_filters_metadata__invoice_date__lte.label"
                          v-model="doc_filters_metadata__invoice_date__lte_value"
                          v-on:keyup.enter="generateFilters"
                        />
                        <date-widget
                          autocomplete="off"
                          :label="doc_filters_metadata__due_date__gte.label"
                          v-model="doc_filters_metadata__due_date__gte_value"
                          v-on:keyup.enter="generateFilters"
                        />
                        <date-widget
                          autocomplete="off"
                          :label="doc_filters_metadata__due_date__lte.label"
                          v-model="doc_filters_metadata__due_date__lte_value"
                          v-on:keyup.enter="generateFilters"
                        /> -->

                        <v-text-field
                          autocomplete="off"
                          :label="doc_filters_third_cif__icontains.label"
                          v-model="doc_filters_third_cif__icontains_value"
                          v-on:keyup.enter="generateFilters"
                        ></v-text-field>
                        <v-text-field
                          autocomplete="off"
                          :label="doc_filters_third_name__icontains.label"
                          v-model="doc_filters_third_name__icontains_value"
                          v-on:keyup.enter="generateFilters"
                        ></v-text-field>
                        <v-select
                          v-if="userData.is_staff || (userData.hasOwnProperty('username') && session_information.hasOwnProperty('username') && (session_information.username != userData.username))"
                          autocomplete="off"
                          :label="doc_filters_state.label"
                          v-model="doc_filters_state_value"
                          :items="doc_filters_state.values"
                          item-text="name"
                          item-value="value"
                          :multiple="doc_filters_state.multiple"
                          clearable
                          v-on:keyup.enter="generateFilters"
                        ></v-select>
                        <v-select
                          v-else-if="permission && (!permission.is_readonly || show_chips_readonly)"
                          autocomplete="off"
                          :label="doc_filters_state.label"
                          v-model="doc_filters_state_value"
                          :items="doc_filters_state.user_values"
                          item-text="text"
                          item-value="value"
                          :multiple="doc_filters_state.multiple"
                          clearable
                          v-on:keyup.enter="generateFilters"
                        ></v-select>
                        <!-- select review_reasons to filter -->
                        <v-select
                          autocomplete="off"
                          :label="doc_filters_review_reasons__icontains.label"
                          v-model="doc_filters_review_reasons__icontains_value"
                          :items="doc_filters_review_reasons__icontains.values"
                          item-text="text"
                          item-value="value"
                          :multiple="doc_filters_review_reasons__icontains.multiple"
                          clearable
                          v-on:keyup.enter="generateFilters"
                        ></v-select>
                        <v-select
                          v-if="userData.is_staff || (userData.hasOwnProperty('username') && session_information.hasOwnProperty('username') && (session_information.username != userData.username))"
                          autocomplete="off"
                          :label="doc_filters_mirror_state.label"
                          v-model="doc_filters_mirror_state_value"
                          :items="doc_filters_state.values"
                          item-text="name"
                          item-value="value"
                          :multiple="doc_filters_mirror_state.multiple"
                          clearable
                          v-on:keyup.enter="generateFilters"
                        ></v-select>
                        <v-select
                            autocomplete="off"
                            v-if="showFilterActividadStr()"
                            :label="doc_filters_actividad_str.label"
                            v-model="doc_filters_actividad_str_value"
                            :items="doc_filters_actividad_str.values"
                            item-text="name"
                            item-value="code"
                            :multiple="doc_filters_actividad_str.multiple"
                            clearable
                            v-on:keyup.enter="generateFilters"
                          ></v-select>
                        <v-select
                          autocomplete="off"
                          v-if="showFilterActividadSelect()"
                          :label="doc_filters_actividad.label"
                          v-model="doc_filters_actividad_value"
                          :items="doc_filters_actividad.values"
                          item-text="name"
                          item-value="code"
                          :multiple="doc_filters_actividad.multiple"
                          clearable
                          v-on:keyup.enter="generateFilters"
                        ></v-select>
                        <v-text-field v-if="showFilterActividad()"
                          v-model="doc_filters_actividad_value" 
                          class="mx-2" 
                          type="number" 
                          :label="doc_filters_actividad.label"
                          v-on:keyup.enter="generateFilters"
                          ></v-text-field>
                        <v-autocomplete
                          v-if="showProjectFields() && userData.available_features['feature_filter_by_project']"
                          autocomplete="off"
                          :label="doc_filters_project.label"
                          v-model="doc_filters_project_value"
                          :items="currentCompany.projects"
                          item-text="name"
                          item-value="id"
                          clearable
                        ></v-autocomplete>
                        <v-autocomplete
                          v-if="showChannelFields()"
                          autocomplete="off"
                          :label="doc_filters_channel.label"
                          v-model="doc_filters_channel_value"
                          :items="currentCompany.channels"
                          item-text="name"
                          item-value="channel_id"
                          clearable
                        ></v-autocomplete>
                        <v-autocomplete
                          v-if="showSectionFields()"
                          autocomplete="off"
                          :label="doc_filters_section.label"
                          v-model="doc_filters_section_value"
                          :items="sections"
                          item-text="name"
                          item-value="section_id"
                          clearable
                        ></v-autocomplete>
                        <v-autocomplete
                          v-if="showDelegationFields()"
                          autocomplete="off"
                          :label="doc_filters_delegation.label"
                          v-model="doc_filters_delegation_value"
                          :items="delegations"
                          item-text="name"
                          item-value="delegation_id"
                          clearable
                        ></v-autocomplete>
                        <v-autocomplete
                          v-if="showDepartmentFields()"
                          autocomplete="off"
                          :label="doc_filters_department.label"
                          v-model="doc_filters_department_value"
                          :items="departments"
                          item-text="name"
                          item-value="department_id"
                          clearable
                        ></v-autocomplete>
                        <v-select
                          v-if="userData.available_features['feature_can_mark_doc_as_punteado']"
                          autocomplete="off"
                          :label="doc_filters_punteado.label"
                          v-model="doc_filters_punteado_value"
                          :items="doc_filters_punteado.values"
                          item-text="name"
                          item-value="value"
                          :multiple="doc_filters_punteado.multiple"
                          clearable
                          v-on:keyup.enter="generateFilters"
                        ></v-select>

                        <v-select
                          v-if="got_feature('feature_is_rectificativa_on_document_list')"
                          autocomplete="off"
                          :label="doc_filters_is_rectificativa.label"
                          v-model="doc_filters_is_rectificativa_value"
                          :items="doc_filters_is_rectificativa.values"
                          item-text="name"
                          item-value="value"
                          :multiple="doc_filters_is_rectificativa.multiple"
                          clearable
                          v-on:keyup.enter="generateFilters"
                        ></v-select>
                        <v-select
                          v-if="got_feature('feature_filter_has_retention')"
                          autocomplete="off"
                          :label="doc_filters_has_retention.label"
                          v-model="doc_filters_has_retention_value"
                          :items="doc_filters_has_retention.values"
                          item-text="name"
                          item-value="value"
                          :multiple="doc_filters_has_retention.multiple"
                          clearable
                          v-on:keyup.enter="generateFilters"
                        ></v-select>
                        <v-select
                          autocomplete="off"
                          :label="doc_filters_has_payment_entry.label"
                          v-model="doc_filters_has_payment_entry_value"
                          :items="doc_filters_has_payment_entry.values"
                          item-text="name"
                          item-value="value"
                          :multiple="doc_filters_has_payment_entry.multiple"
                          clearable
                          @change="onEntryNumberFilterChange"
                          v-on:keyup.enter="generateFilters"
                        ></v-select>

                        <v-select
                          autocomplete="off"
                          :label="doc_filters_paid_account.label"
                          v-model="doc_filters_paid_account_value"
                          :items="doc_filters_paid_account.values"
                          item-text="text"
                          item-value="value"
                          :multiple="doc_filters_paid_account.multiple"
                          clearable
                          @change="generateFilters"
                        ></v-select>
                        <v-select
                          v-if="userData.available_features['feature_bank_reconciliation']"
                          autocomplete="off"
                          :label="doc_filters_payment_state.label"
                          v-model="doc_filters_payment_state_value"
                          :items="doc_filters_payment_state.values"
                          item-text="name"
                          item-value="value"
                          :multiple="doc_filters_payment_state.multiple"
                          clearable
                          v-on:keyup.enter="generateFilters"
                        ></v-select>
                        
                        <date-picker
                          v-if="userData.available_features['feature_bank_reconciliation']"
                          aucomplete="off"
                          :label="doc_filters_payment_date__gte.label"
                          v-model="doc_filters_payment_date__gte_value"
                          @entered="generateFilters"
                        ></date-picker>

                        <date-picker
                          v-if="userData.available_features['feature_bank_reconciliation']"
                          aucomplete="off"
                          :label="doc_filters_payment_date__lte.label"
                          v-model="doc_filters_payment_date__lte_value"
                          @entered="generateFilters"
                        ></date-picker>

                        <v-text-field
                          v-if="userData.available_features['feature_invoice_notes']"
                          autocomplete="off"
                          :label="doc_filters_notes__icontains.label"
                          v-model="doc_filters_notes__icontains_value"
                          v-on:keyup.enter="generateFilters"
                        ></v-text-field>
                          
                      </div>
                    </v-col>
                  </v-row>
                </template>
              </Browser>
            </v-col>
          </v-row>
          
          <v-row class="pa-0 ma-0 mt-4 mb-0">
            <v-col cols="12" class="pa-0 ma-0">
                <v-checkbox
                  v-if="show_select_all"
                  :label="'Aplicar en las ' + currentDocumentsItemsLength + ' facturas'"
                  class="ma-0 pt-4 pl-4 pb-2 pr-0"
                  v-model="send_filters"
                  :disabled="downloading || downloadJobState==='running'"
                  hide-details
                ></v-checkbox>
            </v-col>
          </v-row>

          <div ref="tableContainer" :class="{ 'mobile-container_table': isMobile }">
            <v-divider></v-divider>
            <v-data-table
              name="tabla"
              v-model="selected"
              :headers="computed_headers"
              :items="filteredDocuments"
              :items-per-page="itemsPerPage"
              :class="['elevation-1', 'hover-bg', { 'mobile-table': isMobile }]"
              @click:row="selectRow"
              filterable
              :search="search"
              :server-items-length="currentDocumentsItemsLength"
              show-select
              :options.sync="documentListOptions"
              :footer-props="{
                'items-per-page-options': [5, 10, 100, 1000],
                'items-per-page-text': isMobile ? '' : 'Facturas por página:',
              }"
              :header-props="{
                'sort-by-text': 'Ordenar por',
              }"
              @update:options="changeOptions"
              @item-selected="send_filters = false"
              @toggle-select-all="send_filters = false"
              :loading="loading"
              :mobile-breakpoint="0"
              :fixed-header="got_feature('feature_invoice_header_fixed')"
              :height="got_feature('feature_invoice_header_fixed') ? documentTableHeight : undefined"
            >
              <template v-slot:item.msg_error_contabilizacion="{ item }">
                <v-tooltip bottom :max-width=500>
                  <template v-slot:activator="{ on, attrs }">
                    <div
                        class="tooltip-container"
                        v-bind="attrs"
                        v-on="on"
                    >
                      {{ getErrorAccountingText({error: item.error, kind: item.kind, state: item.state}, true) }}
                    </div>
                  </template>
                  <span>{{ getErrorAccountingText({error: item.error, kind: item.kind, state: item.state}, false) }}</span>
                </v-tooltip>
              </template>

              <template v-slot:top>
                <v-dialog v-if="isSuccessfulApiResponse()" v-model="loading" persistent width="300">
                  <v-card class="pa-4 text-center">
                    <v-row align="center" justify="center">
                      <v-col cols="12">
                        <v-progress-circular indeterminate color="primary" size="32" />
                        <div class="mt-2">Cargando documentos...</div>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-dialog>

                <v-dialog                   
                  v-else-if="!loading && (currentCompany && currentCompany.id) && !isSuccessfulApiResponse()"
                  :value="true" 
                  persistent width="400"
                >
                  <v-card class="pa-4 text-center">
                    <v-row align="center" justify="center">
                      <v-col cols="12">
                        <span class="text-subtitle-1 font-weight-medium" style="color:var(--v-primary-base);">
                          Error consultando listado de facturas...
                        </span>
                      </v-col>
                      <v-col cols="12">
                        <v-btn color="primary" @click="retryAction">
                          Reintentar
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-dialog>
              </template>


              <template v-slot:item.signed_url="{ item }" style="width: 100px">
                <embed
                  v-if="!userData.available_features['feature_miniatura_ampliada'] && (userData.available_features['feature_can_do_massive_rotation'] || permission.is_invited) && item.signed_url!=='' && item.excel_line_index===null"
                  :src="item.signed_url + '#page=1&toolbar=0&navpanes=0&scrollbar=0'"
                  type="application/pdf"
                  width="100px"
                  height="auto"
                />
                <embed
                    v-if="userData.available_features['feature_miniatura_ampliada'] && (userData.available_features['feature_can_do_massive_rotation'] || permission.is_invited) && item.signed_url!=='' && item.excel_line_index===null"
                    :src="item.signed_url + '#page=1&toolbar=0&navpanes=0&scrollbar=0'"
                    type="application/pdf"
                    :width="embedPdfWidth"
                    :height="embedPdfHeight"
                />
              </template>
              <template v-slot:item.punteado="{ item }">
                <div v-if="item.punteado">
                  <v-icon color="var(--v-success-base)">mdi-check</v-icon>
                </div>
              </template>
              <template v-slot:item.is_rectificativa="{ item }">
                <div v-if="item.is_rectificativa">
                  <v-icon color="var(--v-success-base)">mdi-minus-circle-outline</v-icon>
                </div>
              </template>
              <template v-slot:item.intracomunitario="{ item }">
                <div v-if="item.intracomunitario">
                  Sí
                </div>
                <div v-else="item.intracomunitario">
                  No
                </div>
              </template>
              <template v-slot:item.inversion_sujeto_pasivo_iva="{ item }">
                <div v-if="item.inversion_sujeto_pasivo_iva">
                  Sí
                </div>
                <div v-else="item.inversion_sujeto_pasivo_iva">
                  No
                </div>
              </template>
              <template v-slot:item.inversion_sujeto_pasivo_igic="{ item }">
                <div v-if="item.inversion_sujeto_pasivo_igic">
                  Sí
                </div>
                <div v-else="item.inversion_sujeto_pasivo_igic">
                  No
                </div>
              </template>
              <template v-slot:item.entry_number="{ item }">
                <div v-if="(currentCompany && currentCompany.companydb_type.params.company_db_link && item.entry_number)">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn 
                        icon small 
                        v-bind="attrs"
                        v-on="on"
                        @click.stop="linkToExternalEntry(item, currentCompany.companydb_type)"
                      >
                        <v-icon small>
                          mdi-open-in-new
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>Ver factura en {{currentCompany.companydb_type.name}}</span>
                  </v-tooltip>
                </div>
                <div v-else>
                  {{ item.entry_number }}
                </div>
              </template>
              <template v-slot:item.id="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <div
                        class="tooltip-container"
                        @contextmenu.prevent="copyToClipboard(item.id)"
                        v-bind="attrs"
                        v-on="on"
                    >
                      {{ item.id }}
                    </div>
                  </template>
                  <span>Click derecho para copiar ID</span>
                </v-tooltip>
              </template>
            </v-data-table>
          </div>
        </v-card>

      </v-col>
    </v-row>
    <v-snackbar
      v-model="snackbar.isVisible"
      :color="snackbar.color"
    >
      <b>{{ snackbar.text }}</b>
    </v-snackbar>
  </v-container>
</template>

<script>
import ActionSelector from '../components/ActionSelector.vue';
import { client } from "@/api/client";
import { mapActions, mapState, mapGetters } from 'vuex';
import Browser from '../components/Browser.vue';
import MessagePopup from '../components/MessagePopup.vue';
import { mapFields } from 'vuex-map-fields';
import { jobs } from '../api/jobs.js';
import { vuexPrefix, vuexPrefix2 } from "../store/vuex_utils";
import DocTextField from "../components/DocTextField.vue";
import AppDocTextField from "@/components/layout/AppDocTextField.vue";
import MassiveChangesPopUp from '../components/MassiveChangesPopUp.vue';
import DatePicker from '../components/DatePicker.vue'
import ShowHideColumnsDialog from '../components/ShowHideColumnsDialog.vue';
import { ACCOUNTING_DATE_OPTIONS,  } from '../store/constants.js';
import { REGISTRO_DATE_OPTIONS } from '../store/constants.js';
import { isValidDate } from '../utils';

import { PROVIDER_SOMETHING_OPTIONS } from '../store/constants.js';
import { PROVIDER_SOMETHING_OPTIONS2 } from '../store/constants.js';
import UserLeadWorkflow from '../components/UserLeadWorkflow.vue';
import TableListToolbar from '../components/TableListToolbar.vue';
import AppAutocompleteWithApi from '../components/layout/AppAutocompleteWithApi.vue';
import AutocompleteWithApi from '../components/AutocompleteWithApi.vue';
import CopySettings from '../components/CopySettings.vue';
import AppBtn from '@/components/layout/AppBtn.vue';
import AppModalCol from '@/components/layout/AppModalCol.vue';
import AppModalContainer from '@/components/layout/AppModalContainer.vue';
import AppModalPrompt from '@/components/layout/AppModalPrompt.vue';
import AppModalRow from '@/components/layout/AppModalRow.vue';
import AppAutocomplete from "@/components/layout/AppAutocomplete.vue";
import AppSelect from '@/components/layout/AppSelect.vue';
import AppTextField from '@/components/layout/AppTextField.vue';
import ShowDownloadInvoicesFilesDialog from '../components/ShowDownloadInvoicesFilesDialog.vue';
import AppConfirmModal from '@/components/layout/AppConfirmModal.vue';
import SelectorEmpresa from '@/components/SelectorEmpresa.vue';
import { TransferMultiplesDocumentToOtherCompany } from "@/modules/companies/application/TransferMultiplesDocumentToOtherCompany.ts"
import { MigrateDocumentsCompanyCommand } from "@/modules/document/application/MigrateDocumentsCompanyCommand.ts"
import { sync_command_dispatcher, async_command_dispatcher } from '../api/client';
import {InvoicesToForcedPendingSync} from "@/modules/invoices/app/InvoicesToForcedPendingSync";
import {InvoicesToDoneManually} from "@/modules/invoices/app/InvoicesToDoneManually";
import AppSearchBar from "@/components/layout/AppSearchBar.vue";
import { copyToClipboard } from "@/utils/common";
import { get_error_accounting_message } from "@/modules/document/domain/Document";
import { HTTP_STATUS_CODE } from '@/utils/constants';
import { getLinkErrors, hasAnyError } from "@/modules/company/domain/Company";

export default {
  name: "DocumentList",
  components: {
    AppSearchBar,
    AppAutocompleteWithApi,
    AppDocTextField,
    Browser,
    MessagePopup,
    DatePicker,
    DocTextField,
    MassiveChangesPopUp,
    ActionSelector,
    UserLeadWorkflow,
    ShowHideColumnsDialog,
    TableListToolbar,
    AutocompleteWithApi,
    CopySettings,
    AppBtn,
    AppModalCol,
    AppModalContainer,
    AppModalPrompt,
    AppModalRow,
    AppAutocomplete,
    AppSelect,
    AppTextField,
    ShowDownloadInvoicesFilesDialog,
    AppConfirmModal,
    SelectorEmpresa,
  },
  props: {
    companydb_id: {
      type: [String, Number],
    },
  },
  data() {
    /*var headersDict = {};
        docsData.array.forEach(element => {
            element.keys().forEach( key => {
                headersDict[key]={text:key, value:key}
            });
        });*/
    var returnVal = {
      PROVIDER_SOMETHING_OPTIONS,
      PROVIDER_SOMETHING_OPTIONS2,
      search: "",
      snackbar: {
        isVisible: false,
        text: '',
        color: '',
      },
      documentTableHeight: '600px', // Valor inicial, se calcula dinámicamente
      resizeHandler: null, // Handler para el evento resize

      // tags: ['asecan'],//'gpa2016'],
      id: null,
      // action: '',
      // selected: [],
      phoneHeaders:[
        {text:"Phone", value:"phone", width:100},
        {text:"Amount", value:"phone_amount", width:100}
      ],
      // filters: "",
      filters_loaded: false,
      dict_bool: {
        'states': false,
        'tags': false
      },
      options: {},
      dialog: false,
      itemsToDelete: null,
      functions: [],
      kind: '',
      loading_download_excel: false,
      documentName: "",
      documentFormat: "",
      downloading: false,
      loadingAction: false,
      dialogSimulation: false,
      companySimulate: null,
      tagsSimulate: [],
      accounting_date_config: 'invoice_date',
      default_accounting_date: null,
      invalid_default_accounting_date: false,
      dialogChangeCompany: false,
      dialogCopy: false,
      replicateConta:false,
      companyChangeCompany: null,
      listActividadChangeCompany: [],
      actividadChangeCompany: null,
      dialogAddTags: false,
      tagsAddTags: [],
      dialogTraining: false,
      tagsTraining: [],
      ACCOUNTING_DATE_OPTIONS,
      REGISTRO_DATE_OPTIONS,


      dialogMassiveChanges: false,
      dialogMassiveRotation: false,
      dialogMassiveCalculateBaseCuota: false,
      dialogChangeThird: false,
      dialogEntryNumberCSV: false, 
      itemsTypeChangeThird: [],

      dialogMigrateDoneToOtherCompany: false,
      migrateDoneSelectedCompany: null,

      dialog_fix_contasol_docs: false,
      items_to_fix_contasol: [],

      percentMassiveCalculateBaseCuota: '',
      percentMassiveCalculateBaseCuotaValues: [
        {text:'IVA 21 %',value:'vat_21'},
        // {text:'IVA 12 %',value:'vat_12'},
        // {text:'IVA 10.5 %',value:'vat_10_5'},
        {text:'IVA 10 %',value:'vat_10'},
        {text:'IVA 5 %',value:'vat_5'},
        {text:'IVA 4 %',value:'vat_4'},
        {text:'IVA 0 %',value:'vat_ne_0'},
        {text:'IVA 0 % NS',value:'vat_ns_0'},
        {text:'IVA 0 % Ex',value:'vat_0'},
        {text:'IGIC 20 %',value:'igic_20'},
        {text:'IGIC 15 %',value:'igic_15'},
        {text:'IGIC 9.5 %',value:'igic_95'},
        {text:'IGIC 7 %',value:'igic_7'},
        {text:'IGIC 3 %',value:'igic_3'},
        {text:'IGIC 1 %',value:'igic_1'},
        {text:'IGIC 0 %',value:'igic_ne_0'},
        {text:'IGIC 0 % NS',value:'igic_ns_0'},
        {text:'IGIC 0 % Ex.',value:'igic_0'},
        {text:'IGI 0 %',value:'igi_0' },
        {text:'IGI 0 % Ex.',value:'igi_ex_0' },
        {text:'IGI 1 %',value:'igi_1' },
        {text:'IGI 2.5 %',value:'igi_2_5' },
        {text:'IGI 4.5 %',value:'igi_4_5'},
        {text:'IGI 9.5 %',value:'igi_9_5'}
      ],

      docs_ids: [],
      isEnabled: {
        'kind': false,
        'accounting_date_config': false,
        'registro_date_config': false,
        'fiscal': false,
        'bien_inversion': false,
        'deducibilidad': false,
        'criterio_de_caja': false,
        'apply_347': false
      },
      massiveUpdateValues: {
        'kind': '',
        'accounting_date_config': '',
        'registro_date_config': '',
        'default_accounting_date': '',
        'default_registro_date': '',
        'actividad_str': '',
        'apply_347': false,
      },
      changeThirdValues: {
        'third_kind': 'supplier',
        'customerdb': '',
        'supplierdb': '',
        'apply_third_params': true,
      },
      last_entry_number_csv: '',
      loading_massive_changes:false,
      selectedFiscal: '',
      selectedFiscalOption: '',
      selectedFiscalOption2: '',
      selectedIvaCheck: '',
      selectedInversion:'',
      selectedCriterioCaja:'',
      selectedIsComercianteMinorista: '',
      selectedDeducibilidad:'',
      bien_inversion: false,
      'criterio_de_caja':false,
      // is_comerciante_minorista: false, // Este es para cuando el proveedor es un comerciante minorista
      comerciante_minorista: false,
      gasto_iva_percent: 50,

      preview_docs: false,
      send_filters: false,
      JOB_STATES: {
        running: 'running',
        done: 'done'
      },
      JOB_ACTIONS: [
        'download_doc',
        'download_merged_docs',
        'download_excel',
        'download_csv',
        'download_csv_one_line',
        'download_cdb_csv'
      ],
      REFRESH_DATA_ACTIONS: [
        'change_company_doc',
        'copy_doc_to_other_company',
        'multi_continue_flow',
        'contabilizar',
        'delete_doc',
        'force_docs_state_to_done',
        'back_pending_upload_to_pending_review',
        'to_done',
        'mark_as_error_account_connector',
        'change_state_pending_sync_to_done',
        'bck_doc_pending_review_state',
        'docs_accounting_to_pending_review',
        'mark_as_pending_review',
        'change_state_error_already_destination_to_done',
        'change_state_error_already_destination_to_pending_review',
        'change_state_pending_review_to_done',
        'change_state_accounting_to_pending_connect',
        'change_state_pending_connect_to_pending_review',
        'change_state_to_pending_connect',
        'change_state_accounting_to_done',
        'massive_calculate_base_cuota',
        'mark_as_punteado',
        'mark_as_despunteado',
        'massive_change',
        'accounting_payment_move',
        'fix_contasol_documents',
        'massive_fix_round',
        'massive_fix_mismatch_ex0',
        'massive_force_send_documents',
        'massive_third_change',
        'migrate_done_to_other_company',
      ],
      async_job_msg: '',
      copying: false,
      columnConfigDialog: null,
      confirmDocsContabilizar: false,
      msgConfirmDocsContabilizar: '',
      questionConfirmDocsContabilizar: '¿Qué quieres contabilizar?',
      actionDocsContabilizar: '',
      loadingDocsContabilizarAll: false,
      loadingDocsContabilizarPteRev: false,
      confirmDocsDownloadCSV: false,
      msgConfirmDocsDownloadCSV: '',
      questionConfirmDocsDownloadCSV: '¿Qué quieres descargar?',
      actionDocsDownloadCSV: '',
      loadingDocsDownloadCSVAll: false,
      loadingDocsDownloadCSVNoRevReq: false,
      manual_file_connectors : ['a3', 'alfastar', 'contaplus', 'diamacon', 'geyce', 'glasof', 'goldennet' ,'ncs', 'monitor', 'geyce_estimacion', 'glasof_autonomos' , 'goldennet_autonomos', 'ncs_estimacion'],
      markAsPendingReviewDialog: false,
      markAsPendingReviewMsg: 'Elimine el fichero antes de volver a contabilizar las facturas.',
      bckDocPendingReviewDialog: false,
      bckDocPendingReviewMsg: 'Es necesario eliminar el asiento de tu programa contable de forma manual. Esta acción no elimina el registro.',
      markAsErrorAccountConnectorDialog: false,
      markAsErrorAccountConnectorMsg: 'Elimine el fichero antes de volver a contabilizar las facturas.',
      processingCsvFileMsg: 'Procesando fichero CSV... No cierre la ventana hasta que se haya realizado la descarga.',
      showFilters: false,
      embedPdfHeight: 300,
      embedPdfWidth: 'auto',
      validationRules: {
         required: v => !!v || 'Campo obligatorio',
         number: v => !isNaN(v) && parseInt(v) >= 0 || 'Debe ser un campo numérico.',
     },
     documentsToExclude: []
    };
    return returnVal;
  },
  methods: {
    setSnackbar(color, text) {
      this.snackbar.text = text;
      this.snackbar.color = color;
      this.snackbar.isVisible = true;
    },
    onColumnsRestored(data) {
      const color = data.success ? 'success' : 'error';
      this.setSnackbar(color, data.message);
    },
    calculateTableHeight() {
      // Calcular altura disponible dinámicamente basándose en el viewport
      this.$nextTick(() => {
        if (this.$refs.tableContainer) {
          const containerTop = this.$refs.tableContainer.getBoundingClientRect().top;
          // containerTop ya incluye TODO el espacio arriba (header, filtros si visibles, etc)
          const footerAndMargin = 100; // Espacio para footer de paginación + margen inferior

          const availableHeight = window.innerHeight - containerTop - footerAndMargin;
          this.documentTableHeight = Math.max(400, availableHeight) + 'px'; // Mínimo 400px
        }
      });
    },
    isSuccessfulApiResponse() {
      return this.apiResponse && this.apiResponse.status === HTTP_STATUS_CODE.OK;
    },
    async validateDocsExtensions(selectedDocs, restrictionTypes) {
      const result = await this.$store.dispatch('documents/validateDocsExtensions', {
        documents: selectedDocs,
        restrictionTypes
      });

      if (!result.hasRestricted) return false;

      this.showMessage(`Extensiones no permitidas (${result.extensions})`);
      this.loadingAction = false;

      return true;
    },
    docsContainValue(field) {
      const docs = Array.isArray(this.currentDocs) ? this.currentDocs : []

      return docs.some(doc => doc && doc[field] !== '' && doc[field] !== null && doc[field] !== undefined)
    },
    retryAction() {
      this.$store.commit('documents/SET_CURRENT_LOADING', { loading: true });
      this.refreshData();
    },
    getErrorAccountingText(item, trimmed) {
      if (item.error != null && item.state == "error_account_connector") {
        let in_invoice = (item.kind == 'in_invoice')
        let literals = {
          t: in_invoice ? 'proveedor' : 'cliente',
          pm: in_invoice ? 'pago' : 'cobro'
        }
        let error_message = get_error_accounting_message(item.error, literals, false)
        if (error_message != null) {
          if (trimmed && error_message.length > 80) return error_message.substring(0,80) + "..."
          else return error_message
        }
      }
      else return ""
    },
    getEjercicioItemText(item) {
      return `${item.min_date.split('-')[0]}`;
    },
    getEjercicioActualText() {
      if (this.currentCompany) {        
        for (let link in this.currentCompany.links) {
          if (this.doc_filters_ejercicio_value == this.currentCompany.links[link].id) {
            return this.getEjercicioItemText(this.currentCompany.links[link])
          }          
        }                
      }
      return ''      
    },
    showMessage(m, icon){
      const modal = {
        text: m,        
        actionConfirmButton: this.closeMessageModal,
      }

      if (icon) {
        modal.icon = icon
      }

      this.setMessageModal(modal)
    },
    check(field, item){
      return Array.isArray(item.error_json) && item.error_json.includes(field)
    },
    download_excel(){
      this.loading_download_excel=true;
      this.downloadExcel().then(()=>{
        this.loading_download_excel=false;
        this.refreshData()
      }).catch(err=>{
        this.loading_download_excel=false;
        this.showMessage('Algo ha ido mal')
        console.error(err)
      })
    },
    get_docs_ids(states=[]) {
      this.docs_ids = [];
      let all_docs_in_correct_state = true;
      for (let i in this.selected) {
        if (!states.includes(this.selected[i].state)) {
          all_docs_in_correct_state = false;
        }
        this.docs_ids.push(this.selected[i].id);
      }
      return all_docs_in_correct_state;
    },
    selectedAction(actionId) {
      this.action = { id: actionId };
      this.go();
    },
    cancelMultiRetryAll() {
      this.closeMessageModal()
      this.loadingAction = false;
    },
    async goMultiRetryAll() {

      if (await this.validateDocsExtensions(this.selected, 'compressed')) {
        return;
      }

      this.closeMessageModal()
      this.multiRetryAll(this.selected).then(()=>{
        this.showMessage('Las facturas seleccionadas se están reintentando', 'mdi-information-outline')
        this.refreshData()
        this.loadingAction = false;
      }).catch(err=>{
        this.showMessage('Algo ha ido mal')
        this.loadingAction = false;
        console.error(err)
      });
    },
    async loadPaymentAccounts() {

      // Verificar que currentCompany existe antes de continuar
      if (!this.currentCompany || !this.currentCompany.id) {
        return;
      }

      try {
        const params = {
          companydb_id: this.currentCompany.id
        };

        const response = await client.get('get_payment_accounts', { params });

        if (response && response.data && response.data.payment_accounts) {
          // Asignar el objeto completo para evitar mutación directa del estado de Vuex
          this.doc_filters_paid_account = {
            ...this.doc_filters_paid_account,
            values: response.data.payment_accounts
          };

          // Verificar en el siguiente tick que la actualización se propagó
          this.$nextTick(() => {
            console.error('[LOAD_PAYMENT_ACCOUNTS] [nextTick] doc_filters_paid_account.values:', this.doc_filters_paid_account.values);
          });
        } else {
          console.error('[LOAD_PAYMENT_ACCOUNTS] No se encontraron payment_accounts en la respuesta');
        }
      } catch (error) {
        console.error('[LOAD_PAYMENT_ACCOUNTS] Error loading payment accounts:', error);
        console.error('[LOAD_PAYMENT_ACCOUNTS] Error details:', error.response);
      }
    },
    validateMultiRetry() {
      let result = {
        check: true,
        list: []
      };
      for (let i in this.selected) {
        if (this.RETRY_DETECTION_SATES.indexOf(this.selected[i].state) < 0) {
          result.check = false;
          const idStr = this.selected[i].id.toString();
          result.list.push(idStr);
          break;
        }
      }
      return result;
    },
    callDownloadCSV() {
      this.downloadCSV(this.selected).then(response=>{
        this.asyncJobId = response.data['AsyncJob'];
        this.documentName = "facturas";
        this.documentFormat = "csv";
        this.downloadJobState = this.JOB_STATES.running;
      }).catch(err=>{
        this.showMessage('Algo ha ido mal')
        console.error(err)
      });
    },
    callDownloadCSVOneLine() {
      let params = { 'send_filters': this.send_filters, 'docs': this.selected, 'options': this.documentListOptions };
      params['state_filter'] = this.actionDocsDownloadCSV;
      this.actionDocsDownloadCSV = '';
      this.showMessage(this.processingCsvFileMsg, 'mdi-information-outline')
      this.downloadCSVOneLine(params).then(response=>{
        if ('required_review' in response.data) {
          this.confirmDocsDownloadCSV = true;
          this.msgConfirmDocsDownloadCSV = response.data['required_review'];
        }
        else if ('ko' in response.data) {
          this.closeMessageModal()
          this.showMessage(response.data['ko']);
          this.confirmDocsDownloadCSV = false;
        } else {
          this.confirmDocsDownloadCSV = false;
          this.asyncJobId = response.data['AsyncJob'];
          this.documentName = "facturas";
          this.documentFormat = "csv";
          this.downloadJobState = this.JOB_STATES.running;
        }
        this.loadingDocsDownloadCSVAll = false;
        this.loadingDocsDownloadCSVNoRevReq = false;
      }).catch(err=>{
        this.closeMessageModal()
        this.confirmDocsDownloadCSV = false;
        this.loadingDocsDownloadCSVAll = false;
        this.loadingDocsDownloadCSVNoRevReq = false;
        this.showMessage('Algo ha ido mal')
        console.error(err)
      });
    },
    validateDownloadCSV() {
      let count = 0;
      for (var i = 0; i < this.selected.length; i++) {
        if (['pending_review', 'pending_upload', 'error_supplier_not_found', 'error_customer_not_found'].includes(this.selected[i].state)) {
          count += 1;
        }
      }
      let check = count == this.selected.length;
      if (!check) {
        this.showMessage('No se puede descargar el csv de estas facturas.');
      }
      return check;
    },
    checkErrorParams() {
      let err_msg = '';
      if (this.documentActionsErrorParams.hasOwnProperty(this.action.id)) {
        if (this.documentActionsErrorParams[this.action.id].hasOwnProperty('send_filters')) {
          if (this.send_filters != this.documentActionsErrorParams[this.action.id]['send_filters']) {
            err_msg = 'La opción de aplicar en todas las facturas no esta disponible para esta acción.';
          }
        }
        if (this.documentActionsErrorParams[this.action.id].hasOwnProperty('length')) {
          if (this.selected.length != this.documentActionsErrorParams[this.action.id]['length']) {
            err_msg = 'Esta acción solo se puede aplicar en exactamente ' + this.documentActionsErrorParams[this.action.id]['length'] + ' facturas.';
          }
        }
        if (this.documentActionsErrorParams[this.action.id].hasOwnProperty('max_length')) {
          let max_len = this.documentActionsErrorParams[this.action.id]['max_length'];
          if(this.action.id == 'multi_retry_all' && this.im_staff_or_loginas){ // Si es staff o loginas, puede reintentar más (facilitar resolucion incidencias)
              max_len = 100
            }
          if (this.selected.length > max_len) {
            err_msg = 'Esta acción tiene un máximo de ' + max_len + ' facturas.';
            // console.log(max_len, this.im_staff_or_loginas)
          }
        }
        if (this.documentActionsErrorParams[this.action.id].hasOwnProperty('min_length')) {
          if (this.selected.length < this.documentActionsErrorParams[this.action.id]['min_length']) {
            err_msg = 'Esta acción tiene un mínimo de ' + this.documentActionsErrorParams[this.action.id]['min_length'] + ' facturas.';
          }
        }
      }
      return err_msg;
    },
    confirmMarkAsPendingReview() {
      this.markDocsAsPendingReview({ 'send_filters': this.send_filters, 'docs': this.docs_ids }).then(response=>{
        if ('ko' in response.data) {
          this.showMessage(response.data['ko']);
        } else {
          this.asyncJobId = response.data['AsyncJob'];
          this.downloadJobState = this.JOB_STATES.running;
          this.async_job_msg = 'Las facturas seleccionadas vuelven a estar pendientes de revisión.';
        }
        this.loadingAction = false;
        this.markAsPendingReviewDialog = false;
      }).catch(err=>{
        this.showMessage('Algo ha ido mal');
        this.loadingAction = false;
        this.markAsPendingReviewDialog = false;
        console.error(err);
      })
    },
    noMarkAsPendingReview() {
      this.loadingAction = false;
      this.markAsPendingReviewDialog = false;
    },
    confirmBckDocPendingReview() {
      this.bckPendingReviewAction({ 'send_filters': this.send_filters, 'docs': this.docs_ids }).then(response=>{
        if ('ko' in response.data) {
          this.showMessage(response.data['ko']);
        } else {
          this.asyncJobId = response.data['AsyncJob'];
          this.downloadJobState = this.JOB_STATES.running;
          this.async_job_msg = 'Las facturas seleccionadas vuelven a estar pendientes de revisión.';
        }
        this.loadingAction = false;
        this.bckDocPendingReviewDialog = false;
      }).catch(err=>{
        this.showMessage('Algo ha ido mal');
        this.loadingAction = false;
        this.bckDocPendingReviewDialog = false;
        console.error(err);
      })
    },
    noBckDocPendingReview() {
      this.loadingAction = false;
      this.bckDocPendingReviewDialog = false;
    },
    confirmMarkAsErrorAccountConnector() {
      this.markDocAsErrorAccountConnector({ 'send_filters': this.send_filters, 'docs': this.docs_ids }).then(response=>{
        if ('ko' in response.data) {
          this.showMessage(response.data['ko']);
        } else {
          this.asyncJobId = response.data['AsyncJob'];
          this.downloadJobState = this.JOB_STATES.running;
          this.async_job_msg = 'Las facturas seleccionadas ahora estan a error de contabilización.';
        }
        this.loadingAction = false;
        this.markAsErrorAccountConnectorDialog = false;
      }).catch(err=>{
        this.showMessage('Algo ha ido mal');
        this.loadingAction = false;
        this.markAsErrorAccountConnectorDialog = false;
        console.error(err);
      })
    },
    noMarkAsErrorAccountConnector() {
      this.loadingAction = false;
      this.markAsErrorAccountConnectorDialog = false;
    },
    docs_to_done() {
      this.toDone({'send_filters': this.send_filters, 'docs': this.selected, 'last_entry_number_csv': this.last_entry_number_csv}).then(response=>{
        if ('ko' in response.data) {
          this.showMessage(response.data['ko'])
        } else {
          this.async_job_msg = 'Las facturas se han marcado contabilizadas.';
          this.asyncJobId = response.data['AsyncJob'];
          this.downloadJobState = this.JOB_STATES.running;
        }
        this.loadingAction = false;
      }).catch(err=>{
        this.showMessage('Algo ha ido mal')
        console.error(err)
        this.loadingAction = false;
      });
    },
    async go() {
      if (this.JOB_ACTIONS.indexOf(this.action.id) < 0){
        this.asyncJobId = 0;
        this.loadingAction = true;
      }

      // check for errors before executing the action
      let err_msg = undefined
      // check if this actions' id is any of the state related actions
      const stateChangingAction = this.getActions['state'].some(act => act.id === this.action.id)
      if (stateChangingAction) {
        const someDoneMigrated = this.selected.some(doc => doc.state === "done_migrated")
        if (someDoneMigrated) {
          err_msg = "Hay algún documento en estado 'Migrado Contabilizado'. Este estado no se puede modificar."
        }
      }
      if (!err_msg) {
        err_msg = this.checkErrorParams()
      }

      if (!err_msg) {
        switch(this.action.id) {
          case 'delete_doc':
            this.openDeleteDialog(this.selected);
            break;
          case 'download_doc':
            if(this.selected.length!=1 || this.send_filters){
              let docs_ids = []
              for (let i in this.selected) {
                docs_ids.push(this.selected[i].id)
              }
              this.downloadFiles({ send_filters: this.send_filters, docs_ids: docs_ids }).then(response => {
                this.asyncJobId = response.data.AsyncJob;
                this.documentName = "documentos";
                this.documentFormat = "zip";
                this.downloadJobState = this.JOB_STATES.running;
              })
            } else {
              let filename = 'doc_'+this.selected[0].id.toString();
              if (this.selected[0].third_name){
                filename += '_'+this.selected[0].third_name;
              }
              if (this.selected[0].original_file_name) {
                filename += '_'+this.selected[0].original_file_name;
              }
              filename = filename.replace(' ','_').replace("/","_").replace(/\.[^/.]+$/, "") + '.pdf';
              this.downloadFile({"signed_url":this.selected[0].signed_original_url,"filename":filename})
            }
            break;

          case 'merge_docs':
            this.mergeDocuments(this.selected).then(response=>{
              if (Object.keys(response.data).includes('ko')) {
                this.showMessage(response.data['ko']);
              } else {
                this.showMessage('Los documentos se están uniendo.', 'mdi-information-outline')
                this.documentsToExclude = [...this.selected]
              }
              this.refreshData()
              this.loadingAction = false;
            }).catch(err=>{
              this.showMessage('Algo ha ido mal')
              this.loadingAction = false;
              console.error(err)
            });
            break;
          case 'download_merged_docs':
            this.downloadMergedDocuments({send_filters: this.send_filters, docs:this.selected, options:this.documentListOptions}).then(response=>{
              if (Object.keys(response.data).includes('ko')) {
                this.showMessage(response.data['ko']);
                this.loadingAction = false;
              } else {
                this.asyncJobId = response.data['AsyncJob'];
                this.documentName = "documentos";
                this.documentFormat = "pdf";
                this.downloadJobState = this.JOB_STATES.running;
              }
            }).catch(err=>{
              this.showMessage('Algo ha ido mal');
              this.loadingAction = false;
              console.error(err);
            });
            break;

          case 'split_docs':

            if (await this.validateDocsExtensions(this.selected, 'excel')) {
              return;
            }

            this.splitDocument(this.selected).then(()=>{
              this.showMessage('El documento se está separando.', 'mdi-information-outline');
              this.refreshData();
              this.loadingAction = false;
            }).catch(err=>{
              this.showMessage('Algo ha ido mal');
              console.error(err);
              this.loadingAction = false;
            });
            break;

          case 'contabilizar':
            if (this.hasLinkErrors()) {
              this.loadingAction = false
              this.showMessage("Esta empresa tiene ejercicios con fechas erróneas. Revise los ejercicios antes de contabilizar.")
              break
            }
            var do_action = this.get_docs_ids([]);
            let params = {};
            if (this.send_filters) {
              params = await this.getFiltersParamsForRequest(params);
            } else {
              params['ids'] = this.docs_ids;
            }
            params['state_filter'] = this.actionDocsContabilizar;
            this.actionDocsContabilizar = '';
            this.contabilizar(params).then(response=>{
              if ('required_review' in response.data) {
                this.confirmDocsContabilizar = true;
                this.msgConfirmDocsContabilizar = response.data['required_review'];
              }
              else if ('ko' in response.data) {
                this.confirmDocsContabilizar = false;
                this.showMessage(response.data['ko']);
              } else {
                this.confirmDocsContabilizar = false;
                this.async_job_msg = 'Las facturas se estan contabilizando.';
                this.asyncJobId = response.data['AsyncJob'];
                this.downloadJobState = this.JOB_STATES.running;
              }
              this.loadingAction = false;
              this.loadingDocsContabilizarAll = false;
              this.loadingDocsContabilizarPteRev = false;
            }).catch(err=>{
              this.showMessage('Algo ha ido mal')
              this.loadingAction = false;
              this.loadingDocsContabilizarAll = false;
              this.loadingDocsContabilizarPteRev = false;
              console.error(err)
            })
            break;

          case 'multi_continue_flow':

            if (await this.validateDocsExtensions(this.selected, 'compressed')) {
              return;
            }
            
            // TODO: añadir exclusión si hay x filtros
            let doc_req_rev = false;
            for (let i in this.selected) {
              if (['required_review'].includes(this.selected[i].state)) {
                doc_req_rev = true;
              }
            }
            if (!doc_req_rev){
              this.multiContinueFlow({ 'send_filters': this.send_filters, 'docs': this.selected }).then(response=>{
                this.async_job_msg = 'Las facturas seleccionadas se están reintentando.';
                this.asyncJobId = response.data['AsyncJob'];
                this.downloadJobState = this.JOB_STATES.running;
                this.loadingAction = false;
              }).catch(err=>{
                this.showMessage('Algo ha ido mal')
                this.loadingAction = false;
                console.error(err)
              })
            }
            else{
              this.showMessage('Algunos de los documentos seleccionados requieren revisión.')
              this.loadingAction = false;
            }
            break;
          case 'multi_retry_all':
            const result = this.validateMultiRetry();
            if (result.check) {
              console.log('estamos en el result check');
              this.goMultiRetryAll();
            } else if(result.list.length == this.selected.length) {
              console.log('result.list es igual a this.selected list');
              console.log(result.list);
              console.log(this.selected);
              this.showMessage('Las facturas seleccionadas no pueden reintentar la detección');
              this.loadingAction = false;
            } else {
              let invoices = result.list.join(',');
              this.setMessageModal({
                text: 'Las facturas con id:' + invoices + ' no puede reintentar la detección',

                textConfirmButton: 'Aceptar',
                actionConfirmButton: this.goMultiRetryAll,

                showCancelButton: true,
                actionCancelButton: this.cancelMultiRetryAll
              })
            }
            break;

          case 'download_excel':
            this.downloadDocsExcel({send_filters: this.send_filters, docs:this.selected, headers:this.currentHeaders, options:this.documentListOptions}).then(response=>{
                this.asyncJobId = response.data['AsyncJob'];
                this.documentName = "facturas";
                this.documentFormat = "xlsx";
                this.downloadJobState = this.JOB_STATES.running;
            }).catch(err=>{
              this.showMessage('Algo ha ido mal')
              console.error(err)
            })
            break;

          case 'download_csv':
            if (this.validateDownloadCSV()) {
              this.callDownloadCSV();
            }
            break;

          case 'download_csv_one_line':
          case 'download_cdb_csv':
            this.callDownloadCSVOneLine();
            break;

          case 'to_done':
            var do_action = this.get_docs_ids(['pending_upload']);
            if (do_action) {
              if (this.got_feature("feature_fill_entry_number_done")) {
                this.openEntryNumberCSV();
              }
              else {
                this.docs_to_done();
              }
            } else {
              this.showMessage('Para usar esta acción es necesario que todos los documentos esten pendientes de carga.')
              this.loadingAction = false;
            }
            break;

          case 'simulate_doc':
            this.openSimulatedDialog(this.selected)
            break;

          case 'change_company_doc':
            this.openChangeCompanyDialog(this.selected)
            break;
          case 'copy_doc_to_other_company':
            this.openCopyDialog()
            break;
          case 'replicate_doc_to_other_company':
            this.replicateConta = true;
            this.openCopyDialog();
            break;
          case 'massive_third_change':
            this.setSuppliers(this.currentCompany['id']);
            this.setCustomers(this.currentCompany['id']);
            this.openChangeThirdDialog(this.selected);
            break;
          case 'massive_change':
            // TODO: añadir exclusión si hay x filtros
            this.docs_ids = []
            for (let i in this.selected) {
              this.docs_ids.push(this.selected[i].id)
            }
            this.setSuppliers(this.currentCompany['id'])
            this.setCustomers(this.currentCompany['id'])
            this.dialogMassiveChanges = true;
            break;

          case 'massive_fix_round':
            this.docs_ids = []
            for (let i in this.selected) {
              this.docs_ids.push(this.selected[i].id)
            }
            this.massiveFixRound({ 'send_filters': this.send_filters, 'docs': this.docs_ids }).then(response=>{
              if ('ko' in response.data) {
                this.showMessage(response.data['ko']);
              } else {
                this.asyncJobId = response.data['AsyncJob'];
                this.downloadJobState = this.JOB_STATES.running;
                this.async_job_msg = 'Las facturas se están redondeando a 2 decimales.';
              }
              this.loadingAction = false;
            }).catch(err=>{
              this.showMessage('Algo ha ido mal.');
              this.loadingAction = false;
              console.error(err);
            });
            break;

          case 'massive_fix_mismatch_ex0':
            this.docs_ids = []
            for (let i in this.selected) {
              this.docs_ids.push(this.selected[i].id)
            }
            //console.log("docs_ids", this.docs_ids)
            const idsFixable = this.selected
                  .filter(doc => doc.extra_fields && doc.extra_fields.flag_aplicar_descuadre_Ex0)
                  .map(doc => doc.id);
            //console.log("idsFixable", idsFixable)
          
            this.massiveFixMismatchEx0({ 'send_filters': this.send_filters, 'docs': idsFixable }).then(response=>{
              if ('ko' in response.data) {
                this.showMessage(response.data['ko']);
              } else {
                this.asyncJobId = response.data['AsyncJob'];
                this.downloadJobState = this.JOB_STATES.running;

                if (idsFixable.length > 0 && idsFixable.length <=1) {
                  this.async_job_msg = `La factura con id ${idsFixable.join(', ')} se está ajustando pasando el descuadre a Ex 0`;
                } else if ((idsFixable.length > 1 && idsFixable.length <=10)) {
                  this.async_job_msg = `Las facturas con ids ${idsFixable.join(', ')} se están ajustando pasando el descuadre a Ex 0`;
                } else {
                  this.async_job_msg = 'Las facturas se están ajustando pasando el descuadre a Ex 0';
                }
              }
              this.loadingAction = false;
            }).catch(err=>{
              this.showMessage('Algo ha ido mal.');
              this.loadingAction = false;
              console.error(err);
            });
            break;

          case 'massive_force_send_documents':
            this.docs_ids = []
            for (let i in this.selected) {
              this.docs_ids.push(this.selected[i].id)
            }
            this.massiveForceSendDocuments({ 'send_filters': this.send_filters, 'docs': this.docs_ids }).then(response=>{
              if ('ko' in response.data) {
                this.showMessage("Documentos en proceso de ser enviados");
              }
              this.loadingAction = false;
            }).catch(err=>{
              this.showMessage('Algo ha ido mal.');
              this.loadingAction = false;
              console.error(err);
            });
            break;

          case 'add_tags_doc':
            this.openAddTagsDialog(this.selected)
            break;

          case 'create_training_doc':
            this.openTrainingDialog(this.selected)
            break;

          case 'mark_as_error_account_connector':
            var do_action = this.get_docs_ids(['pending_sync']);
            if (do_action) {
              let docs_ids = [];
              for (let i in this.selected) {
                docs_ids.push(this.selected[i].id);
              }
              if(this.manual_file_connectors.includes(this.currentCompany.companydb_type.value)){
                this.markAsErrorAccountConnectorDialog = true;
              }
              else{
                this.confirmMarkAsErrorAccountConnector();
              }
            } else {
              this.showMessage('Para usar esta acción es necesario que todas las facturas seleccionadas estén pendientes de sincronización.');
              this.loadingAction = false;
            }
            break;

          case 'massive_rotation':
            this.docs_ids = []
            for (let i in this.selected) {
              this.docs_ids.push(this.selected[i].id)
            }
            this.dialogMassiveRotation = true;
            break;

          case 'mark_as_pending_review':
            var do_action = this.get_docs_ids(['pending_sync']);
            if (do_action) {
              if(this.manual_file_connectors.includes(this.currentCompany.companydb_type.value)){
                this.markAsPendingReviewDialog = true;
              }
              else {
                this.confirmMarkAsPendingReview();
              }
            } else {
              this.showMessage('Para usar esta acción es necesario que todas las facturas seleccionadas estén pendientes de sincronización.');
              this.loadingAction = false;
            }
            break;

          case 'force_docs_state_to_done':
            var do_action = this.get_docs_ids(['error_account_connector']);
            if (do_action) {
              this.forceDocsStateToDone({ 'send_filters': this.send_filters, 'docs': this.docs_ids }).then(response=>{
                if ('ko' in response.data) {
                  this.showMessage(response.data['ko']);
                } else {
                  this.asyncJobId = response.data['AsyncJob'];
                  this.downloadJobState = this.JOB_STATES.running;
                  this.async_job_msg = 'Las facturas selecionadas ahora estan contabilizadas.';
                }
                this.loadingAction = false;
              }).catch(err=>{
                this.showMessage('Algo ha ido mal')
                this.loadingAction = false;
                console.error(err)
              });
            } else {
              this.showMessage('Para usar esta acción es necesario que todas las facturas seleccionadas estén en error de contabilización.');
              this.loadingAction = false;
            }
            break;

          case 'bck_doc_pending_review_state':
            var do_action = this.get_docs_ids(['done','done_manually', 'done_with_warning']);
            if (do_action) {
              this.bckDocPendingReviewDialog = true;
            } else {
              this.showMessage('Para usar esta acción es necesario que todas las facturas seleccionadas estén contabilizadas.');
              this.loadingAction = false;
            }
            break;

          case 'docs_accounting_to_pending_review':
            var do_action = this.get_docs_ids(['accounting']);
            if (do_action) {
              this.accountingToPendingReviewAction({ 'send_filters': this.send_filters, 'docs': this.docs_ids }).then(response=>{
                if ('ko' in response.data) {
                  this.showMessage(response.data['ko']);
                } else {
                  this.asyncJobId = response.data['AsyncJob'];
                  this.downloadJobState = this.JOB_STATES.running;
                  this.async_job_msg = 'Las facturas seleccionadas vuelven a estar pendientes de revisión';
                }
                this.loadingAction = false;
              }).catch(err=>{
                this.showMessage('Algo ha ido mal');
                this.loadingAction = false;
                console.error(err)
              });
            } else {
              this.showMessage('Para usar esta acción es necesario que todas las facturas seleccionadas estén en estado Contabilizando...');
              this.loadingAction = false;
            }
            break;

          case 'mark_as_punteado':
            this.docs_ids = [];
            for (let i in this.selected) {
              this.docs_ids.push(this.selected[i].id);
            }
            this.markAsPunteado({ 'send_filters': this.send_filters, 'docs': this.docs_ids }).then(resp => {
              this.asyncJobId = resp.data['AsyncJob'];
              this.downloadJobState = this.JOB_STATES.running;
              this.async_job_msg = 'Las facturas selecionadas se han marcado como punteado.';
              this.loadingAction = false;
            }).catch(err=>{
              this.showMessage('Algo ha ido mal');
              this.loadingAction = false;
              console.error(err);
            })
            break;

          case 'mark_as_despunteado':
            this.docs_ids = [];
            for (let i in this.selected) {
              this.docs_ids.push(this.selected[i].id);
            }
            this.markAsDespunteado({ 'send_filters': this.send_filters, 'docs': this.docs_ids }).then(resp => {
              this.asyncJobId = resp.data['AsyncJob'];
              this.downloadJobState = this.JOB_STATES.running;
              this.async_job_msg = 'Las facturas selecionadas se han marcado como despunteado.';
              this.loadingAction = false;
            }).catch(err=>{
              this.showMessage('Algo ha ido mal');
              this.loadingAction = false;
              console.error(err);
            })
            break;

          case 'back_pending_upload_to_pending_review':
            var do_action = this.get_docs_ids(['pending_upload']);
            if (do_action) {
              this.backPendingUploadToPendingReview({ 'send_filters': this.send_filters, 'docs': this.docs_ids }).then(response => {
                if ('ko' in response.data) {
                  this.showMessage(response.data['ko']);
                } else {
                  this.asyncJobId = response.data['AsyncJob'];
                  this.downloadJobState = this.JOB_STATES.running;
                  this.async_job_msg = 'Las facturas seleccionadas vuelven a estar pendientes de revisión';
                }
                this.loadingAction = false;
              }).catch(error => {
                this.showMessage('Algo ha ido mal');
                this.loadingAction = false;
                console.error(error);
              });
            } else {
              this.showMessage('Para usar esta acción es necesario que todas las facturas seleccionadas estén en Pendiente Carga');
              this.loadingAction = false;
            }
            break;

          case 'change_state_pending_sync_to_done':
            var do_action = this.get_docs_ids(['pending_sync']);
            if (do_action) {
              this.changeStatePendingSyncToDone({ 'send_filters': this.send_filters, 'docs': this.docs_ids }).then(response => {
                if ('ko' in response.data) {
                  this.showMessage(response.data['ko']);
                } else {
                  this.asyncJobId = response.data['AsyncJob'];
                  this.downloadJobState = this.JOB_STATES.running;
                  this.async_job_msg = 'Las facturas selecionadas se han marcado como contabilizadas.';
                }
                this.loadingAction = false;
              }).catch(error => {
                this.showMessage('Algo ha ido mal');
                this.loadingAction = false;
                console.error(error);
              });
            } else {
              this.showMessage('Para usar esta acción es necesario que todas las facturas seleccionadas estén en Pendiente de Sincronización');
              this.loadingAction = false;
            }
            break;

          case 'change_state_error_already_destination_to_done':
            var do_action = this.get_docs_ids(['error_already_destination']);
            if (do_action) {
              this.changeStateErrorAlreadyDestinationToDone({ 'send_filters': this.send_filters, 'docs': this.docs_ids }).then(response => {
                if ('ko' in response.data) {
                  this.showMessage(response.data['ko']);
                } else {
                  this.asyncJobId = response.data['AsyncJob'];
                  this.downloadJobState = this.JOB_STATES.running;
                  this.async_job_msg = 'Las facturas selecionadas se han marcado como contabilizadas.';
                }
                this.loadingAction = false;
              }).catch(error => {
                this.showMessage('Algo ha ido mal');
                this.loadingAction = false;
                console.error(error);
              });
            } else {
              this.showMessage('Para usar esta acción es necesario que todas las facturas seleccionadas estén en Error: Ya existente en destino.');
              this.loadingAction = false;
            }
            break;

          case 'change_state_error_already_destination_to_pending_review':
            var do_action = this.get_docs_ids(['error_already_destination']);
            if (do_action) {
              this.changeStateErrorAlreadyDestinationToPendingReview({ 'send_filters': this.send_filters, 'docs': this.docs_ids }).then(response => {
                if ('ko' in response.data) {
                  this.showMessage(response.data['ko']);
                } else {
                  this.asyncJobId = response.data['AsyncJob'];
                  this.downloadJobState = this.JOB_STATES.running;
                  this.async_job_msg = 'Las facturas selecionadas se han marcado como Pdte. de Revisión.';
                }
                this.loadingAction = false;
              }).catch(error => {
                this.showMessage('Algo ha ido mal');
                this.loadingAction = false;
                console.error(error);
              });
            } else {
              this.showMessage('Para usar esta acción es necesario que todas las facturas seleccionadas estén en Error: Ya existente en destino.');
              this.loadingAction = false;
            }
            break;

          case 'change_state_pending_review_to_done':
            var do_action = this.get_docs_ids(['pending_review']);
            if (do_action) {
              this.changeStatePendingReviewToDone({ 'send_filters': this.send_filters, 'docs': this.docs_ids }).then(response => {
                if ('ko' in response.data) {
                  this.showMessage(response.data['ko']);
                } else {
                  this.asyncJobId = response.data['AsyncJob'];
                  this.downloadJobState = this.JOB_STATES.running;
                  this.async_job_msg = 'Las facturas selecionadas se han marcado como Contabilizadas.';
                }
                this.loadingAction = false;
              }).catch(error => {
                this.showMessage('Algo ha ido mal');
                this.loadingAction = false;
                console.error(error);
              });
            } else {
              this.showMessage('Para usar esta acción es necesario que todas las facturas seleccionadas estén en Pdte. de Revisión.');
              this.loadingAction = false;
            }
            break;

          case 'change_state_accounting_to_pending_connect':
            var do_action = this.get_docs_ids(['accounting']);
            if (do_action) {
              this.changeStateAccountingToPendingConnect({ 'send_filters': this.send_filters, 'docs': this.docs_ids, 'session_username': this.session_information.username }).then(response => {
                if ('ko' in response.data) {
                  this.showMessage(response.data['ko']);
                } else {
                  this.asyncJobId = response.data['AsyncJob'];
                  this.downloadJobState = this.JOB_STATES.running;
                  this.async_job_msg = 'Las facturas selecionadas se han marcado como Contabilizando.';
                }
                this.loadingAction = false;
              }).catch(error => {
                this.showMessage('Algo ha ido mal');
                this.loadingAction = false;
                console.error(error);
              });
            } else {
              this.showMessage('Para usar esta acción es necesario que todas las facturas seleccionadas estén en Contabilizando...');
              this.loadingAction = false;
            }
            break;

          case 'change_state_pending_connect_to_pending_review':
            var do_action = this.get_docs_ids(['pending_connect',
            'accounting_invoice', 'accounting_aplifisa_fiscal'])

            if (do_action) {
              this.changeStatePendingConnectToPendingReview({
                'send_filters': this.send_filters,
                'docs': this.docs_ids,
                'session_username': this.session_information.username
              })
              .then(response => {
                if ('ko' in response.data) {
                  this.showMessage(response.data['ko'])
                } else {
                  this.asyncJobId = response.data['AsyncJob']
                  this.downloadJobState = this.JOB_STATES.running
                  this.async_job_msg = 'Las facturas selecionadas se han marcado como Pendientes de Revisión.'
                }
              })
              .catch(error => {
                this.showMessage('Algo ha ido mal')
                console.error(error)
              })
              .finally(() => { this.loadingAction = false })
            } else {
              this.showMessage('Para usar esta acción es necesario que todas las facturas seleccionadas estén en Contabilizando');
              this.loadingAction = false;
            }
            break
          case 'change_state_accounting_to_pending_sync':

            var do_action = this.get_docs_ids(['accounting'])
            if (do_action && !this.send_filters){
              let res = await new InvoicesToForcedPendingSync(async_command_dispatcher).run(this.docs_ids)
              console.log(res)
              let job_id = res.job_id
              let aj_info;
              while(aj_info===undefined || aj_info.data.state!='done'){
                aj_info = await client.get('jobs/jobs/' + job_id)
                console.log(aj_info)
                await setTimeout(()=>{}, 3000)
              }
              this.showMessage('Las facturas selecionadas se han marcado como Pendientes de Sincronización.')
              this.loadingAction = false
              this.refreshData()

            } else {
              this.loadingAction = false
              if (!do_action){
                this.showMessage('Para usar esta acción es necesario que todas las facturas seleccionadas estén en Contabilizando...')
              }
              else{
                this.showMessage('Para esta acción no puede seleccionar todas las facturas')
                }
            }
            break

          case 'change_state_to_pending_connect':
            this.docs_ids = []
            for (let i in this.selected) {
              this.docs_ids.push(this.selected[i].id)
            }
            this.changeStateToPendingConnect({
              'send_filters': this.send_filters,
              'docs': this.docs_ids,
              'session_username': this.session_information.username
            })
            .then(response => {
              if ('ko' in response.data) {
                this.showMessage(response.data['ko'])
              } else {
                this.asyncJobId = response.data['AsyncJob']
                this.downloadJobState = this.JOB_STATES.running
                this.async_job_msg = 'Las facturas seleccionadas se han marcado como Contabilizando.'
              }
            })
            .catch(error => {
              this.showMessage('Algo ha ido mal')
              console.error(error)
            })
            .finally(() => { this.loadingAction = false })
            break

          case 'change_state_to_done_manually':
            this.docs_ids = []
            for (let i in this.selected) {
              this.docs_ids.push(this.selected[i].id)
            }
            if (!this.send_filters){
              let res = await new InvoicesToDoneManually(sync_command_dispatcher).run(this.docs_ids)
              this.showMessage('Las facturas selecionadas se han marcado como Contabilizadas Manualmente.')
              this.loadingAction = false
              this.refreshData()
            } else {
              this.loadingAction = false
                this.showMessage('Para esta acción no puede seleccionar todas las facturas')
            }
            break;

          case 'change_state_accounting_to_done':
            var do_action = this.get_docs_ids(['accounting'])
            var args = { 'send_filters': this.send_filters, 'docs': this.docs_ids, 'session_username': this.session_information.username }
            if (do_action) {
              this.changeStateAccountingToDone(args)
                .then(response => {
                  if ('ko' in response.data) {
                    this.showMessage(response.data['ko'])
                  } else {
                    this.asyncJobId = response.data['AsyncJob'];
                    this.downloadJobState = this.JOB_STATES.running;
                    this.async_job_msg = 'Las facturas selecionadas se han marcado como Contabilizadas.';
                  }
                })
                .catch(error => {
                  this.showMessage('Algo ha ido mal')
                  console.error(error)
                })
                .finally(() => { this.loadingAction = false })
            } else {
              this.showMessage('Para usar esta acción es necesario que todas las facturas seleccionadas estén en Contabilizando...')
              this.loadingAction = false
            }
            break

          case 'accounting_payment_move':
            var do_action = this.get_docs_ids(['done', 'done_manually','done_with_warning']);
            if (do_action) {
              this.generatePaymentMoves({ 'send_filters': this.send_filters, 'docs': this.docs_ids }).then(response => {
                if ('ko' in response.data) {
                  this.showMessage(response.data['ko']);
                } else {
                  this.asyncJobId = response.data['AsyncJob'];
                  this.downloadJobState = this.JOB_STATES.running;
                  this.async_job_msg = 'Asientos de pago generados correctamente.';
                }
                this.loadingAction = false;
              }).catch(error => {
                this.showMessage('Algo ha ido mal');
                this.loadingAction = false;
                console.error(error);
              });
            } else {
              this.showMessage('Para usar esta acción es necesario que todas las facturas seleccionadas esten Contabilizadas');
              this.loadingAction = false;
            }
            break;

          case 'massive_calculate_base_cuota':
            this.docs_ids = []
            for (let i in this.selected) {
              this.docs_ids.push(this.selected[i].id)
            }
            this.dialogMassiveCalculateBaseCuota = true;
            break;

          case 'fix_contasol_documents':
            this.docs_ids = []
            for (let i in this.selected) {
              this.docs_ids.push(this.selected[i].id)
            }
            this.openFixContasolDocsDialog(this.docs_ids);
            break;
          case 'transferir':
            this.docs_ids = []
            for (let i in this.selected) {
              this.docs_ids.push(this.selected[i].id)
            }
            await new TransferMultiplesDocumentToOtherCompany(sync_command_dispatcher, this).run(this.docs_ids)
            break;
          
          case 'migrate_done_to_other_company':
            const allowed_states = ['done', 'done_manually', 'done_with_warning', 'done_migrated']
            const doc_states = this.selected.map(item => item.state)

            if (doc_states.every(state => allowed_states.includes(state))) {
              this.docs_ids = []
              this.docs_ids = this.selected.map(item => item.id)
              this.dialogMigrateDoneToOtherCompany = true // open dialog
            }
            else {
              this.showMessage("Para usar esta acción es necesario que todos los documentos estén en estado Contabilizado / Contabilizado Manualmente / Contabilizado con Advertencia")
              this.migrateDoneSelectedCompany = null
              this.loadingAction = false
            }
        }
      } else {
        this.showMessage(err_msg);
        this.loadingAction = false;
      }
    },

    selectRow(data, index) {
      //this.$store.dispatch('configuration/setForceRightBar',true);
      let data_index = this.currentDocs.indexOf(data)
      this.setCurrentIndex(data_index)
      this.resetDocument()
      let params = { name: "document-detail", params: { document: data.id } };
      this.$router.push(params);

      // let routeData = this.$router.resolve({name: 'document-detail', params: { document: data.id }});
      // window.open(routeData.href, '_blank');
    },
    // downloadFile(file_name){
    //   axios({
    //     method:'get',
    //     url:'https://adp-media.s3-eu-west-1.amazonaws.com/'+file_name,
    //     responseType: 'arraybuffer'
    //   }).then(response => {
    //     let fileURL = window.URL.createObjectURL(new Blob([response.data]));
    //     let fileLink = document.createElement("a");

    //     fileLink.href = fileURL;
    //     fileLink.setAttribute("download", "data.pdf");
    //     document.body.appendChild(fileLink);

    //     fileLink.click();

    //   })
    // },
    openDeleteDialog(items) {
      this.itemsToDelete = items;

      this.setMessageModal({
        text: 'Se van a eliminar los documentos seleccionados.',
        showQuestion: true,
        textQuestion: '¿Está seguro?',

        textConfirmButton: 'Borrar',
        actionConfirmButton: this.deleteItem,

        showCancelButton: true,
        actionCancelButton: this.noDeleteItem
      })
    },

    async deleteItem() {
      this.closeMessageModal();
      let params = {};
      if (this.send_filters) {
        params = await this.getFiltersParamsForRequest(params);
      } else {
        let doc_ids = []
        for(let i in this.itemsToDelete){
          doc_ids.push(this.itemsToDelete[i]['id'])
        }
        params['doc_ids'] = doc_ids;
      }
      client.post("delete_documents/" , params).then(response => {
        if (Object.keys(response.data).includes('ko')) {
            this.showMessage(response.data['ko']);
            this.loadingAction = false;
        }
        else {
          this.asyncJobId = response.data['AsyncJob'];
          this.async_job_msg = 'Las facturas se han borrado.';
          this.downloadJobState = this.JOB_STATES.running;
          this.loadingAction = false
          this.itemsToDelete = null;
        }
      }).catch(err => {
        console.error(err);
        this.showMessage('Algo ha ido mal');
        this.loadingAction = false;
      });
    },
    noDeleteItem() {
      this.closeMessageModal();
      this.itemsToDelete = null;
      this.loadingAction = false;
    },
    //Action Copy Simulation Document
    openSimulatedDialog(items) {
      this.dialogSimulation = true;
      this.itemsToSimulate = items;
    },
    simulateItem() {
      this.invalid_default_accounting_date = false;
      //Date validations
      if(this.accounting_date_config=='configurated'){
        if(isValidDate(this.default_accounting_date)){
          let d_str_split = this.default_accounting_date.split('/')
          let d = new Date(d_str_split[1]+'/'+d_str_split[0]+'/'+d_str_split[2])
          this.default_accounting_date=this.date_to_string(d)
        }else{
          this.invalid_default_accounting_date = true;
          this.loadingAction = false;
        }
      }
      if (!this.invalid_default_accounting_date) {
        this.dialogSimulation = false
        let doc_ids = [];
        for(let i in this.itemsToSimulate){
          doc_ids.push(this.itemsToSimulate[i]['id'])
        }
        let cdb_id = this.companySimulate.id;
        let params = {'doc_ids': doc_ids,
                      'cdb_id': cdb_id,
                      'tags': this.tagsSimulate,
                      'accounting_date_config': this.accounting_date_config,
                      'default_accounting_date': this.default_accounting_date
                      }
        client.post("create_simulation_copies/" , params)
          .then(response=>{
              if ('ko' in response.data) {
                this.showMessage(response.data['ko'])
              }
              else {
                this.showMessage('Simulaciones de las facturas seleccionadas creadas.', 'mdi-information-outline')
                this.refreshData();
                this.itemsToSimulate = null;
                this.action = '';
                this.companySimulate = null;
                this.tagsSimulate = [];
                this.accounting_date_config = 'invoice_date';
                this.default_accounting_date = null;
              }
              this.loadingAction = false;
          }).catch(err=>{
            this.showMessage('Algo ha ido mal')
            this.loadingAction = false;
            console.error(err)
          })
      }
    },
    noSimulateItem() {
      this.dialogSimulation = false;
      this.itemsToSimulate = null;
      this.action = '';
      this.companySimulate = null;
      this.tagsSimulate = [];
      this.accounting_date_config = 'invoice_date';
      this.default_accounting_date = null;
      this.loadingAction = false;
    },
    openFixContasolDocsDialog(items) {
      this.items_to_fix_contasol = items;
      this.setMessageModal({
        text: 'Se van a volver a descargar los documentos pdf en contasol de los documentos seleccionados.',
        showQuestion: true,
        textQuestion: '¿Está seguro?',

        actionConfirmButton: this.fixContasolDocsAction,

        showCancelButton: true,
        actionCancelButton: this.noFixContasolDocs
      })
    },
    fixContasolDocsAction() {
      this.closeMessageModal();
      var do_action = this.get_docs_ids(['done','done_manually', 'done_with_warning']);
      if (do_action) {
        this.fixContasolDocuments({ 'send_filters': this.send_filters, 'docs': this.docs_ids }).then(response => {
          if ('ko' in response.data) {
            this.showMessage(response.data['ko']);
          } else {
            this.asyncJobId = response.data['AsyncJob'];
            this.downloadJobState = this.JOB_STATES.running;
            this.async_job_msg = 'Se están subiendo los documentos pdf a contasol.';
          }
          this.loadingAction = false;
        }).catch(error => {
          this.showMessage('Algo ha ido mal.');
          this.loadingAction = false;
          console.error(error);
        });
      } else {
        this.showMessage('Para usar esta acción es necesario que todas las facturas seleccionadas estén Contabilizadas.');
        this.loadingAction = false;
      }
    },
    noFixContasolDocs() {
      this.closeMessageModal();
      this.items_to_fix_contasol = [];
      this.loadingAction = false;
    },
    date_to_string(d){
      var mm = d.getMonth() + 1; // getMonth() is zero-based
      var dd = d.getDate();

      return [(dd>9 ? '' : '0') + dd,
          (mm>9 ? '' : '0') + mm,
          d.getFullYear()
         ].join('/');
    },
    openCopyDialog() {
      this.dialogCopy = true;
    },
    closeCopyDialog() {
      this.dialogCopy = false;
      this.action = '';
      this.companyChangeCompany = null;
      this.replicateConta = false;
      this.loadingAction = false;
    },
    async copyDocsToOtherCDB() {
      this.dialogCopy = false
      let cdb_id = this.companyChangeCompany.id;
      let params = {'new_cdb_id': cdb_id, 'replicate_conta': this.replicateConta };
      if (this.send_filters) {
        params = await this.getFiltersParamsForRequest(params);
      } else {
        let doc_ids = [];
        for(let i in this.selected){
          doc_ids.push(this.selected[i]['id'])
        }
        params['doc_ids'] = doc_ids;
      }
      client.post("copy_docs_to_other_company/" , params)
        .then(response=>{
            this.companyChangeCompany = null;
            if ('ko' in response.data) {
              this.showMessage(response.data['ko'])
            } else {
              this.asyncJobId = response.data.AsyncJob;
              this.downloadJobState = this.JOB_STATES.running;
              this.async_job_msg = 'Los documentos seleccionados se han clonado correctamente en la empresa seleccionada.'
            }
            this.loadingAction = false;
        }).catch(err=>{
          this.showMessage('Algo ha ido mal')
          this.loadingAction = false;
          this.companyChangeCompany = null;
          this.replicateConta = false;
          console.error(err)
        })
    },
    //Action Change Document's Company
    openChangeCompanyDialog(items) {
      this.dialogChangeCompany = true;
      this.itemsToChangeCompany = items;
    },
    async changeCompanyItem() {
      this.dialogChangeCompany = false
      let cdb_id = this.companyChangeCompany.id;
      let params = {'new_cdb_id': cdb_id, };
      if (this.send_filters) {
        params = await this.getFiltersParamsForRequest(params);
      } else {
        let doc_ids = [];
        for(let i in this.itemsToChangeCompany){
          doc_ids.push(this.itemsToChangeCompany[i]['id'])
        }
        params['doc_ids'] = doc_ids;
      }
      if (!isNaN(this.actividadChangeCompany) && parseInt(Number(this.actividadChangeCompany)) == this.actividadChangeCompany && !isNaN(parseInt(this.actividadChangeCompany, 10))) {
        params['actividad'] = this.actividadChangeCompany;
      }
      client.post("change_company_doc/" , params)
        .then(response=>{
            if ('ko' in response.data) {
              this.showMessage(response.data['ko'])
            } else {
              this.asyncJobId = response.data.AsyncJob;
              this.downloadJobState = this.JOB_STATES.running;
              this.async_job_msg = 'Los documentos seleccionados ahora pertenecen a la empresa seleccionada.'
            }
            this.loadingAction = false;
        }).catch(err=>{
          this.showMessage('Algo ha ido mal')
          this.loadingAction = false;
          console.error(err)
        })
    },
    noChangeCompanyItem() {
      this.dialogChangeCompany = false;
      this.itemsToChangeCompany = null;
      this.action = '';
      this.companyChangeCompany = null;
      this.actividadChangeCompany = null;
      this.loadingAction = false;
    },
    async confirmMigrateDoneToOtherCompany() { // Action Migrate Done Documents to Other Company
      this.dialogMigrateDoneToOtherCompany = false
      const dest_company_id = this.migrateDoneSelectedCompany ? this.migrateDoneSelectedCompany.id : null
      const orig_company_id = this.currentCompany.id

      const args = {
        document_ids: this.docs_ids,
        from_company_id: orig_company_id,
        dest_company_id: dest_company_id,
        user_id: this.userData.id
      }

      const cmd = new MigrateDocumentsCompanyCommand(async_command_dispatcher, this)
      await cmd.run(args)
    },
    cancelMigrateDoneToOtherCompany() {
      this.dialogMigrateDoneToOtherCompany = false;
      this.migrateDoneSelectedCompany = null;
      this.action = '';
      this.loadingAction = false;
    },
    //Action Add Tags Document
    openAddTagsDialog(items) {
      this.dialogAddTags = true;
      this.itemsToAddTags = items;
    },
    addTagsItem() {
      this.dialogAddTags = false
      let doc_ids = [];
      for(let i in this.itemsToAddTags){
        doc_ids.push(this.itemsToAddTags[i]['id'])
      }
      let params = {'doc_ids': doc_ids, 'tags': this.tagsAddTags}
      client.post("add_tags_doc/" , params)
        .then(response=>{
            this.showMessage('Tags añadidos correctamente.');
            this.refreshData();
            this.itemsToAddTags = null;
            this.action = '';
            this.tagsAddTags = [];
            this.loadingAction = false;
        }).catch(err=>{
          this.showMessage('Algo ha ido mal')
          this.loadingAction = false;
          console.error(err)
        })
    },
    noAddTagsItem() {
      this.dialogAddTags = false;
      this.itemsToAddTags = null;
      this.action = '';
      this.tagsAddTags = [];
      this.loadingAction = false;
    },
    //Action Create Training Doc Copy
    openTrainingDialog(items) {
      this.dialogTraining = true;
      this.itemsTraining = items;
    },
    trainingItem() {
      this.dialogTraining = false
      let doc_ids = [];
      for(let i in this.itemsTraining){
        doc_ids.push(this.itemsTraining[i]['id'])
      }
      let params = {'doc_ids': doc_ids, 'tags': this.tagsTraining }
      client.post("create_training_copies/" , params)
        .then(response=>{
            this.showMessage('Copias training creadas de las facturas seleccionadas.', 'mdi-information-outline')
            this.refreshData();
            this.itemsTraining = null;
            this.action = '';
            this.tagsTraining = [];
            this.loadingAction = false;
        }).catch(err=>{
          this.showMessage('Algo ha ido mal')
          this.loadingAction = false;
          console.error(err)
        })
    },
    noTrainingItem() {
      this.dialogTraining = false;
      this.itemsTraining = null;
      this.action = '';
      this.tagsTraining = [];
      this.loadingAction = false;
    },

    defaultParamsChangeThirdDialog() {
      this.changeThirdValues = {
        'third_kind': 'supplier',
        'customerdb': '',
        'supplierdb': '',
        'apply_third_params': true,
      }
    },
    onChangeKingChangeThirdDialog() {
      this.changeThirdValues['customerdb'] = '';
      this.changeThirdValues['supplierdb'] = '';
    },
    openChangeThirdDialog(items) {
      this.dialogChangeThird = true;
      this.itemsToChangeThird = items;
      this.defaultParamsChangeThirdDialog();
      this.itemsTypeChangeThird = [{'id':'supplier', 'name': 'Proveedor'}];
      if (!this.got_feature("feature_hide_out_invoice")) {
        this.itemsTypeChangeThird.push({'id':'customer', 'name': 'Cliente'});
      }
    },
    async changeThirdItem() {
      this.dialogChangeThird = false;
      let third_kind = this.changeThirdValues.third_kind;
      let params = {'companydb_id': this.currentCompany.id,
                    'third_kind': third_kind,
                    'apply_params': this.changeThirdValues.apply_third_params,
      }
      if (third_kind == 'supplier') {
        params['third_id'] = this.changeThirdValues['supplierdb'];
      }
      else if (third_kind == 'customer') {
        params['third_id'] = this.changeThirdValues['customerdb'];
      }
      if (this.send_filters) {
         params = await this.getFiltersParamsForRequest(params);
      } else {
        let doc_ids = [];
        for(let i in this.itemsToChangeThird){
          doc_ids.push(this.itemsToChangeThird[i]['id'])
        }
        params['doc_ids'] = doc_ids;
      }
      client.post("massive_third_change_api/" , params)
        .then(response=>{
            if ('ko' in response.data) {
              this.showMessage(response.data['ko'])
            } else {
              this.asyncJobId = response.data.AsyncJob;
              this.downloadJobState = this.JOB_STATES.running;
              this.async_job_msg = 'Los documentos tienen asignado el tercero seleccionado.'
            }
            this.loadingAction = false;
        }).catch(err=>{
          this.showMessage('Algo ha ido mal')
          this.loadingAction = false;
          console.error(err)
        })
    },
    noChangeThirdItem() {
      this.dialogChangeThird = false;
      this.itemsToChangeThird = null;
      this.action = '';
      this.loadingAction = false;
    },

    openEntryNumberCSV() {
      if (this.$refs && this.$refs.entryNumberDialogForm) {
         this.$refs.entryNumberDialogForm.reset();
     }
      this.last_entry_number_csv = '';
      this.dialogEntryNumberCSV = true;
    },
    entryNumberCSV() {
      const formIsValid = this.$refs.entryNumberDialogForm.validate();
      if (formIsValid) {
        this.dialogEntryNumberCSV = false;
        this.docs_to_done();
      }
    },
    noEntryNumberCSV() {
      this.dialogEntryNumberCSV = false;
      this.action = '';
      this.loadingAction = false;
    },

    isAllBoolTrue() {
      var bool = true;
      for (var key in this.currentDictBool) {
        if (this.currentDictBool[key] == false) {
          bool = false;
        }
      }
      return bool;
    },

    setFiltersIdValue(idValue) {
      this.setFiltersDataIdValue(idValue);
    },

    setFiltersStateValue(stateValue) {
      this.setFiltersDataStateValue(stateValue);
    },

    setFiltersSearchValue(searchValue) {
      this.setFiltersDataSearchValue(searchValue);
    },

    setFiltersSearchDuplicateValue(searchValue){
      this.setFiltersDataSearchDuplicateValue(searchValue)
    },

    setDocumentFilterKind(kind){
      this.setDocumentKind(kind)
    },

    setFiltersTagsValue(tagsValue) {
      this.setFiltersDataTagsValue(tagsValue);
    },

    setFiltersEjercicioUserValues() {
      if (this.currentCompany) {
        let user_values = []        
        for (let link in this.currentCompany.links) {
          user_values.push({value: this.currentCompany.links[link].id, text: this.getEjercicioItemText(this.currentCompany.links[link])})          
        }        
        this.setFilterDataEjercicioUserValues(user_values)        
      }            
    },

    async jobDone() {
      if (this.REFRESH_DATA_ACTIONS.includes(this.action.id)) {
        this.refreshData();
        this.closeMessageModal()
        this.showMessage(this.async_job_msg, 'mdi-information-outline')
      } else if (this.action.id == 'download_merged_docs') {
        try {
          const resp = await jobs.getJobFile({ id: this.asyncJobId });
          let fileURL = resp.data.url;
          const response = await fetch(fileURL)
          const blob = await response.blob();
          const url = await URL.createObjectURL(blob)
          const a = document.createElement("a");
          a.href = url;
          a.download = this.documentName + "." + this.documentFormat;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        } catch(err) {
          console.debug(err)
        }
      } else { // else if (['download_doc', 'download_excel'].includes(action.id)) {}
        try {
          this.downloading=true;
          const response = await jobs.getJobFile({ id: this.asyncJobId });
          let fileURL = response.data.url;
          let fileLink = document.createElement("a");
          fileLink.href = fileURL;
          fileLink.setAttribute("download", this.documentName + "." + this.documentFormat);
          document.body.appendChild(fileLink);
          fileLink.click();
          this.downloading=false;
        } catch(err) {
          console.debug(err);
          this.downloading = false;
        }
      }
      if (['download_csv', 'download_csv_one_line', 'download_cdb_csv'].includes(this.action.id)) {
        this.closeMessageModal()
        this.refreshData();
      }
    },

    isDate(value) {
      return isValidDate(value);
    },

    ...mapActions(['setSearch','mergeDocuments','splitDocument','downloadExcel','contabilizar', 'getAsyncJob']),
    setEntryNumberValue(entryNumberValue) {
      this.setFiltersDataEntryNumberValue(entryNumberValue);
    },

    setAccountMoveNumberValue(accountMoveNumberValue) {
      this.setFiltersDataAccountMoveNumberValue(accountMoveNumberValue);
    },
    showFilterActividadStr() {
      return this.got_feature('feature_actividad_str_field') && this.got_feature('feature_actividad_selector') && this.hasMasterPermission('actividad_str') && !this.currentCompany.hide_activities_master;
    },
    showFilterActividadSelect() {
      return this.doc_filters_actividad.values.length > 0 && this.hasMasterPermission('actividad') && !this.currentCompany.hide_activities_master;
    },
    showFilterActividad() {
      return this.doc_filters_actividad.values.length == 0 && this.hasMasterPermission('actividad') && !this.currentCompany.hide_activities_master;
    },


    ...mapActions(['setSearch','mergeDocuments','splitDocument','downloadExcel','contabilizar','setSuppliers','setCustomers','waitForLoggedIn','copySettingsFromCdb']),
    ...mapActions({ setCurrentDocs: "documents/setCurrentDocs",
                    setCurrentIndex: "documents/setCurrentIndex",
                    resetDocument: "documents/resetDocument",
                    setCurrentFilters: "documents/setCurrentFilters",
                    setFiltersDataTagsValues: "documents/setFiltersDataTagsValues",
                    setDictBoolTags: "documents/setDictBoolTags",
                    setFiltersLoaded: "documents/setFiltersLoaded",
                    refreshData: "documents/refreshData",
                    setFiltersDataIdValue: "documents/setFiltersDataIdValue",
                    setFiltersDataStateValue: "documents/setFiltersDataStateValue",
                    setFiltersDataSearchValue: "documents/setFiltersDataSearchValue",
                    setFiltersDataSearchDuplicateValue: "documents/setFiltersDataSearchDuplicateValue",
                    setDocumentKind: "documents/setDocumentKind",
                    setFiltersDataTagsValue: "documents/setFiltersDataTagsValue",
                    setFiltersDataEntryNumberValue: "documents/setFiltersDataEntryNumberValue",
                    setFiltersDataAccountMoveNumberValue: "documents/setFiltersDataAccountMoveNumberValue",
                    setFilterDataEjercicioUserValues: "documents/setFilterDataEjercicioUserValues",
                    downloadFile:"documents/downloadFile",
                    downloadFiles:"documents/downloadFiles",
                    multiContinueFlow:"documents/multiContinueFlow",
                    multiRetryAll: "documents/multiRetryAll",
                    setItemsPerPage: "documents/setItemsPerPage",
                    setCurrentHeaders: "documents/setCurrentHeaders",
                    downloadMergedDocuments:'documents/downloadMergedDocuments',
                    downloadDocsExcel:'documents/downloadExcel',
                    getFilters: 'documents/getFilters',
                    generateFilters: 'documents/generateFilters',
                    cleanFilters: 'documents/cleanFilters',
                    refreshUserData: "me/refreshUserData",
                    downloadCSV: "documents/downloadCSV",
                    downloadCSVOneLine: "documents/downloadCSVOneLine",
                    toDone: "documents/toDone",
                    massiveUpdate: 'documents/massiveUpdateObject',
                    markDocAsErrorAccountConnector: "documents/markDocAsErrorAccountConnector",
                    massiveRotation: "documents/massiveRotation",
                    massiveCalculateBaseCuota: "documents/massiveCalculateBaseCuota",
                    markDocsAsPendingReview: "documents/markDocsAsPendingReview",
                    forceDocsStateToDone: "documents/forceDocsStateToDone",
                    bckPendingReviewAction: "documents/bckPendingReviewAction",
                    accountingToPendingReviewAction: "documents/accountingToPendingReviewAction",
                    markAsPunteado: "documents/markAsPunteado",
                    markAsDespunteado: "documents/markAsDespunteado",
                    getRetryDetectionStates: "documents/getRetryDetectionStates",
                    backPendingUploadToPendingReview: "documents/backPendingUploadToPendingReview",
                    changeStatePendingSyncToDone: "documents/changeStatePendingSyncToDone",
                    changeStateErrorAlreadyDestinationToDone: "documents/changeStateErrorAlreadyDestinationToDone",
                    changeStateErrorAlreadyDestinationToPendingReview: "documents/changeStateErrorAlreadyDestinationToPendingReview",
                    changeStatePendingReviewToDone: "documents/changeStatePendingReviewToDone",
                    changeStateAccountingToPendingConnect: "documents/changeStateAccountingToPendingConnect",
                    changeStatePendingConnectToPendingReview: "documents/changeStatePendingConnectToPendingReview",
                    changeStateToPendingConnect: "documents/changeStateToPendingConnect",
                    changeStateAccountingToDone: "documents/changeStateAccountingToDone",
                    generatePaymentMoves: "documents/generatePaymentMoves",
                    getFiltersParamsForRequest: "documents/getFiltersParamsForRequest",
                    setAllCurrentsFilters: "documents/setAllCurrentsFilters",
                    setCurrentStateChip: "documents/setCurrentStateChip",
                    getDocumentActionsErrorParams: "documents/getDocumentActionsErrorParams",
                    fixContasolDocuments: "documents/fixContasolDocuments",
                    massiveFixRound: "documents/massiveFixRound",
                    massiveFixMismatchEx0: "documents/massiveFixMismatchEx0",
                    massiveForceSendDocuments: "documents/massiveForceSendDocuments",
                    setColumnDataIfParams: "documents/setColumnDataIfParams",
                    getCompanyActivities: "documents/getCompanyActivities",

                    setMessageModal: 'messageModal/setModal',
                    closeMessageModal: 'messageModal/closeModal',
                    updateObject: 'documents/updateObject',
                    removeAllFilters: 'documents/removeAllFilters',
                    }),
    ...mapActions({
      setSettings: "setting_repository/setSettings"
    }),
    // Barra de filtros nueva
    async updateFilter(params){
      this.updateObject(params);
      this.generateFilters();
    },
    async removeAllFilt(p){
      this.removeAllFilters();
      this.generateFilters();
    },
    onEntryNumberFilterChange(val) {
      this.$nextTick(() => {
        this.generateFilters();
      });
    },

    // End - Barra de filtros nueva
    selectChip(filter){
      this.selectedStateChip=filter.values;
      if (filter.values!='all'){
        this.statesFilter=filter.states
      }
      else{
        this.statesFilter=undefined
      }
      let key = this.keyStateChip + this.currentCompany.id;
      this.setSettings({settings: key, value: this.selectedStateChip});
      this.generateFilters();

      if (this.is_mobile)  this.showFilters = false;
    },
    unselectChip(){
      this.selectedStateChip='all'
      this.statesFilter=undefined
      let key = this.keyStateChip + this.currentCompany.id;
      this.setSettings({settings: key, value: this.selectedStateChip});
      this.generateFilters();
    },
    cancelMassiveChanges() {
      this.dialogMassiveChanges = false;
      let keys = Object.keys(this.isEnabled);
      for (let i in keys) {
        this.isEnabled[keys[i]] = false;
      }
      this.massiveUpdateValues = {
        'kind': '',
        'accounting_date_config': '',
        'default_accounting_date': '',
        'registro_date_config': '',
        'default_registro_date': '',
        'actividad_str': '',
        'apply_347': false,
      }
      this.selectedFiscal = '';
      this.selectedFiscalOption = '';
      this.selectedFiscalOption2 = '';
      this.selectedIvaCheck = '';
      this.selectedInversion = '';
      this.selectedCriterioCaja = '';
      this.selectedIsComercianteMinorista = '';
      this.selectedDeducibilidad = '';
      this.loadingAction = false;
    },
    doMassiveChanges() {
      let params = {};
      let keys = Object.keys(this.isEnabled);
      for (let i in keys) {
        if (this.isEnabled[keys[i]]) {
          if (keys[i] == 'fiscal') {
            params['inversion_sujeto_pasivo_iva'] = false;
            params['inversion_sujeto_pasivo_igic'] = false;
            params['intracomunitario'] = false;
            params['extracomunitario'] = false;
            params['is_comerciante_minorista'] = false;
            params['no_sujeta'] = false;
            if ([
              'inversion_sujeto_pasivo_iva',
              'inversion_sujeto_pasivo_igic',
              'extracomunitario',
              'is_comerciante_minorista'
            ].includes(this.selectedFiscal)) {
              params[this.selectedFiscal] = true;
              params[this.selectedFiscal + '_percent'] = this.selectedFiscalOption;
            } else if (this.selectedFiscal == 'intracomunitario') {
              params[this.selectedFiscal] = true;
              params[this.selectedFiscal + '_percent'] = this.selectedFiscalOption;
              params[this.selectedFiscal + '_type'] = this.selectedFiscalOption2;
            } else {
              params[this.selectedFiscal] = true;
            }
          } else if (keys[i] == 'bien_inversion') {
            params['bien_inversion'] = this.bien_inversion ? true : false;
          } else if (keys[i] == 'criterio_de_caja') {
            params['criterio_de_caja'] = this.criterio_de_caja ? true : false;
          // } else if (keys[i] == 'is_comerciante_minorista') {
          //   params['is_comerciante_minorista'] = this.is_comerciante_minorista ? true : false;
          } else if (keys[i] == 'deducibilidad') {
            if (this.selectedIvaCheck == 'iva_igic_no_deducible') {
              params['iva_igic_no_deducible'] = true;
              params['gasto_iva_parcial'] = false;
              params['iva_parcial'] = false;
              params['prorate'] = false;
              if (this.userData.available_features['feature_comerciante_minorista'] && this.currentCompany && this.currentCompany.companydb_type.params && ((!this.currentCompany.companydb_type.params.hasOwnProperty('hide')) || (this.currentCompany.companydb_type.params.hide && !this.currentCompany.companydb_type.params.hide.includes('comerciante_minorista')))) {
                params['comerciante_minorista'] = this.comerciante_minorista;
              }
            } else if (this.selectedIvaCheck == 'gasto_iva_parcial') {
              if (this.gasto_iva_percent >= 0 && this.gasto_iva_percent <= 100) {
                params['iva_igic_no_deducible'] = false;
                params['gasto_iva_parcial'] = true;
                params['iva_parcial'] = false;
                params['gasto_iva_percent'] = this.gasto_iva_percent;
                params['prorate'] = false;
              }
            } else if (this.selectedIvaCheck == 'iva_parcial') {
              if (this.gasto_iva_percent >= 0 && this.gasto_iva_percent <= 100) {
                params['iva_igic_no_deducible'] = false;
                params['gasto_iva_parcial'] = false;
                params['iva_parcial'] = true;
                params['gasto_iva_percent'] = this.gasto_iva_percent;
                params['prorate'] = false;
              }
            } else if (this.selectedIvaCheck == 'prorate') {
              params['iva_igic_no_deducible'] = false;
              params['gasto_iva_parcial'] = false;
              params['iva_parcial'] = false;
              params['prorate'] = true;
            }
            else{
              params['iva_igic_no_deducible'] = false;
              params['gasto_iva_parcial'] = false;
              params['iva_parcial'] = false;
              params['prorate'] = false;
            }
          } 
          else if(keys[i] == 'doc_number'){
            params['doc_number'] = this.massiveUpdateValues['doc_number']?this.massiveUpdateValues['doc_number']:null
          }
          else if(keys[i] == 'doc_number_prefix'){
            params['doc_number_prefix'] = this.massiveUpdateValues['doc_number_prefix']?this.massiveUpdateValues['doc_number_prefix']:''
          }
          else if (keys[i] == 'apply_347') {
            params['apply_347'] = !!this.massiveUpdateValues['apply_347'];
          }
          else {
            params[keys[i]] = this.massiveUpdateValues[keys[i]];

            if (keys[i] == 'accounting_date_config' && this.massiveUpdateValues['default_accounting_date']) {
              params['default_accounting_date'] = this.massiveUpdateValues['default_accounting_date'];
            }
            if (keys[i] == 'registro_date_config' && this.massiveUpdateValues['default_registro_date']) {
              params['default_registro_date'] = this.massiveUpdateValues['default_registro_date'];
            }
          }
        }
      }
      this.loading_massive_changes=true
      this.massiveUpdate({
        'url': 'massive_update_document/',
        'send_filters': this.send_filters,
        'ids': this.docs_ids,
        'params': params,
        'currentCompany': this.currentCompany.id
      }).then(response => {
        this.asyncJobId = response.data['AsyncJob'];
        this.downloadJobState = this.JOB_STATES.running;
        this.async_job_msg = 'Cambios realizados con éxito';
        this.loadingAction = false;
        this.loading_massive_changes = false;
        this.cancelMassiveChanges();
      }).catch(err => {
        console.error(err);
        this.loading_massive_changes=false
        this.showMessage('Algo ha ido mal')
        this.loadingAction = false;
      });
    },

    doMassiveRotation(rotation) {
      this.dialogMassiveRotation = false;
      this.massiveRotation({'ids': this.docs_ids, 'rotation': rotation}).then(() => {
        this.showMessage('Las facturas seleccionadas se estan rotando.', 'mdi-information-outline')
        this.refreshData();
      }).catch(err => {
        console.error(err);
        this.showMessage('Algo ha ido mal');
      })
      .finally(() => {this.loadingAction = false});
    },

    doMassiveCalculateBaseCuota() {
      this.dialogMassiveCalculateBaseCuota = false;
      this.massiveCalculateBaseCuota({
        'send_filters': this.send_filters,
        'ids': this.docs_ids,
        'percent': this.percentMassiveCalculateBaseCuota
      }).then(response => {
        this.asyncJobId = response.data['AsyncJob'];
        this.downloadJobState = this.JOB_STATES.running;
        this.async_job_msg = 'Se esta calculando la base y la cuota para estas facturas.';
        this.loadingAction = false;
      }).catch(error => {
        this.showMessage('Algo ha ido mal.');
        this.loadingAction = false;
        console.error(error);
      });
    },
    cancelMassiveCalculateBaseCuota() {
      this.dialogMassiveCalculateBaseCuota = false;
      this.loadingAction = false;
    },
    toggleFiscal(){
      if (this.selectedFiscal == this.lastSelectedFiscal) {
        this.selectedFiscal = undefined
      }
    },
    toggleIvaCheck(){
      if (this.selectedIvaCheck == this.lastSelectedIvaCheck) {
        this.selectedIvaCheck = undefined
      }
    },
    toggleInversion(){
      if (this.selectedInversion == this.lastSelectedInversion) {
        this.selectedInversion = undefined
      }
    },
    toggleCriterioCaja(){
      if (this.selectedCriterioCaja == this.lastSelectedCriterioCaja) {
        this.selectedCriterioCaja = undefined
      }
    },
    toggleIsComercianteMinorista() {
      if (this.selectedIsComercianteMinorista == this.lastSelectedIsComercianteMinorista) {
        this.selectedIsComercianteMinorista = undefined;
      }
    },
    toogleDeducibilidad(){
      if (this.selectedDeducibilidad == this.lastSelectedDeducibilidad) {
        this.selectedDeducibilidad = undefined
      }
    },
    resetFiscalOption() {
      this.selectedFiscalOption = undefined;
      this.selectedFiscalOption2 = undefined;
    },
    async getCompanyActivityList() {
      let params = {
        'companydb_id': this.companyChangeCompany.id,
        'feature_code': 'feature_actividad_selector',
        'field_show': 'actividad'
      };
      this.listActividadChangeCompany =  await this.getCompanyActivities(params);
    },
    showActivityField(company, field) {
      let show = company && company.companydb_type && company.companydb_type.params && company.companydb_type.params.show && company.companydb_type.params.show.includes(field);
      return show;
    },
    changeOptions(){
      this.refreshData();
      this.setItemsPerPage(this.documentListOptions['itemsPerPage']);
    },
    async copySettings(copy_cdb_from){
      this.copying = true;
      const data = await this.copySettingsFromCdb({"settings_code":"document_list_headers","cdb_id":this.currentCompany.id,"copy_cdb_from":copy_cdb_from})
      await this.setColumnDataIfParams(data)
      this.columnConfigDialog = false;
      this.copying = false;
      setTimeout(() => {
        this.columnConfigDialog = null;
      }, 1)
    },

    linkToExternalEntry(invoice, dbType) {
      const dbTypeName = dbType.value
      const url = dbType.params.company_db_link
      const invoiceType = invoice.kind_display
      const externalEntryID = invoice.entry_number
      let completeUrl = ''

      if (externalEntryID) {
        if (dbTypeName === 'holded') {
          let slug = ''

          if (invoiceType === 'Proveedor') {
            slug = 'expenses/list#open:purchase';
          } else if (invoiceType === 'Cliente') {
            slug = 'sales/revenue#open:invoice';
          }

          completeUrl = url.replace('${slug}', slug).replace('${id}', externalEntryID);
        } else if (dbTypeName === 'odoo') {
          const userSettings = this.userData.default_settings;
          const odooUrl = userSettings.odoo.con_url || '';
          if (odooUrl) {
            completeUrl = `${odooUrl}/web#id=${externalEntryID}&view_type=form&model=account.move`;

          }
        }
        window.open(completeUrl, '_blank');
      }
    },
    show_actions_ro() {
      return this.permission.is_readonly && (this.got_feature('feature_delete_docs_ro') || this.got_feature('feature_download_docs_excel_ro') || this.got_feature('feature_download_docs_file_ro'));
    },
    cancelDocsContabilizarModal() {
      this.confirmDocsContabilizar = false;
    },
    confirmDocsContabilizarModal(action) {
      if (action == 'todos') {
        this.loadingDocsContabilizarAll = true;
      }
      else {
        this.loadingDocsContabilizarPteRev = true;
      }
      this.actionDocsContabilizar = action;
      this.selectedAction('contabilizar');
    },
    cancelDocsDownloadCSVModal() {
      this.closeMessageModal()
      this.confirmDocsDownloadCSV = false;
    },
    confirmDocsDownloadCSVModal(action) {
      this.closeMessageModal()
      if (action == 'todos') {
        this.loadingDocsDownloadCSVAll = true;
      }
      else {
        this.loadingDocsDownloadCSVNoRevReq = true;
      }
      this.actionDocsDownloadCSV = action;
      this.callDownloadCSVOneLine();
    },
    copyToClipboard,
    embedPdfSize(height, width){
      this.embedPdfHeight = height;
      this.embedPdfWidth = width;
      this.refreshData();
    },
    disableMassiveChanges() {

      const anyEnabled = Object.values(this.isEnabled || {}).some(fieldIsEnabled => fieldIsEnabled);

      const invalidAccountingDate =
        this.isEnabled.accounting_date_config &&
        this.massiveUpdateValues.accounting_date_config == 'configurated' &&
        !this.isDate(this.massiveUpdateValues.default_accounting_date);

      const invalidRegistroDate =
        this.isEnabled.registro_date_config &&
        this.massiveUpdateValues.registro_date_config == 'configurated' &&
        !this.isDate(this.massiveUpdateValues.default_registro_date);

      return !anyEnabled || invalidAccountingDate || invalidRegistroDate;

    },
    hasMasterPermission(master) {
      return this.currentCompany && this.currentCompany.companydb_type && this.currentCompany.companydb_type.params && this.currentCompany.companydb_type.params.show && 
      this.currentCompany.companydb_type.params.show.includes(master)
    },
    hasLinkErrors() {
      if (!this.currentCompany || !this.currentCompany.links) return false
      return hasAnyError(getLinkErrors(this.currentCompany.links))
    },
    showProjectFields() {
      return this.got_feature('feature_document_projects') && this.hasMasterPermission('project') && !this.currentCompany.hide_projects_master;
    },
    showChannelFields() {
      return this.got_feature('feature_channel') && this.hasMasterPermission('channel') && !this.currentCompany.hide_channels_master;
    },
    showSectionFields() {
      return this.got_feature('feature_sections') && this.hasMasterPermission('section') && !this.currentCompany.hide_sections_master;
    },
    showDelegationFields() {
      return this.got_feature('feature_delegations') && this.hasMasterPermission('delegation') && !this.currentCompany.hide_delegations_master;
    },
    showDepartmentFields() {
      return this.got_feature('feature_departments') && this.hasMasterPermission('department') && !this.currentCompany.hide_departments_master
    },
  },
  created() {
    this.RETRY_DETECTION_SATES = [];
    this.getRetryDetectionStates().then(response => {
      this.RETRY_DETECTION_SATES = response;
    });
    
    this.setAllCurrentsFilters(true);
    this.setCurrentStateChip(true);
    this.search=this.search_state;
    this.functions = [
      this.setFiltersIdValue,
      this.setFiltersStateValue,
      this.setFiltersSearchValue,
      this.setFiltersSearchDuplicateValue,
      this.setDocumentFilterKind,
      this.setFiltersTagsValue,
      this.setEntryNumberValue,
      this.setAccountMoveNumberValue,
    ];
    this.cancelMassiveChanges();
  },
  async mounted() {
    await this.waitForLoggedIn();
    await this.refreshUserData();
    await this.getDocumentActionsErrorParams();
    if (this.userData && this.userData.user_role && this.userData.user_role.value === "customer_other_docs") {
      this.$router.push({ 'name': 'generic-document-list', 'params': { 'companydb_id': this.currentCompany.id }})
    }
    if (this.userData && this.userData.available_features && this.userData.available_features['feature_document_filter_bar']){
      this.setFiltersEjercicioUserValues()
      this.updateObject({key:'ejercicio',value: this.doc_filters_ejercicio_value ,text: this.getEjercicioActualText()})
    }

    // Cargar cuentas de pago disponibles
    console.log('[MOUNTED] Llamando a loadPaymentAccounts');
    await this.loadPaymentAccounts();
    console.log('[MOUNTED] loadPaymentAccounts completado');

    // Calcular altura inicial de la tabla
    this.calculateTableHeight();

    // Recalcular altura cuando se redimensiona la ventana
    this.resizeHandler = () => this.calculateTableHeight();
    window.addEventListener('resize', this.resizeHandler);
  },
  beforeDestroy() {
    // Limpiar el listener de resize
    if (this.resizeHandler) {
      window.removeEventListener('resize', this.resizeHandler);
    }
  },
  computed: {
    filteredDocuments() {
      const currentDocs = this.currentDocs || []
      const selectedIds = this.documentsToExclude ? this.documentsToExclude.map(doc => doc.id) : []
      return currentDocs.filter(doc => !selectedIds.includes(doc.id))
    },
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    title() {
      return 'Contabilidad de facturas'
    },
    computed_headers() {
      
      let headers = this.currentHeaders.slice();
      if (this.currentCompany && this.currentCompany.companydb_type.value == 'inbox'){
        headers = [{
              text: "Empresa detectada",
              value: "detected_company_name",
              width: 200
            }].concat(headers);
      }
      if (headers.length) {
        if (this.preview_docs && (this.userData.available_features['feature_can_do_massive_rotation'] || this.permission.is_invited)) {
          if (headers[0]['value'] != 'signed_url') {
            headers = [{
              text: "PDF",
              value: "signed_url",
              width: 100
            }].concat(headers);
          }
        } else {
          if (headers[0]['value'] == 'signed_url') {
            headers.shift();
          }
        }
      }
      return headers;
    },
    show_select_all() {
      let show = false;
      let length_items = this.currentDocs.length;
      let length_selected = this.selected.length;
      if (length_items == length_selected) {
        show = true;
      }
      return show;
    },
    show_chips_readonly(){
      for(let i in this.currentHeaders){
        let header = this.currentHeaders[i]
        if(header['value'] == 'state_display'){
          return true
        }
      }
      return false
    },
    show_chip_pending_sync() {
      return !!(this.currentCompany
          && this.currentCompany.companydb_type
          && this.currentCompany.companydb_type.params
          && this.currentCompany.companydb_type.params['show']
          && this.currentCompany.companydb_type.params['show'].includes('pending_sync'));
    },
    ...mapGetters([
      'get_companydbs',
      "get_suppliers",
      "get_customers",
      "is_mobile",
      "got_feature",
    ]),
    ...mapGetters({
      currentDocs: 'documents/currentDocuments',
      currentHeaders: 'documents/currentHeaders',
      currentActions: 'documents/currentActions',

      currentDocumentsItemsLength: 'documents/currentDocumentsItemsLength',
      currentFiltersLoaded: 'documents/currentFiltersLoaded',
      currentDictBool: 'documents/currentDictBool',
      loading: 'documents/loading',
      loading_info:'documents/loading_info',
      currentMainFilters: 'documents/currentMainFilters',
      userData: 'me/userData',
      itemsPerPage: 'documents/itemsPerPage',
      availableDocs: "me/availableDocs",
      permission: 'permissions/permission',
      keyStateChip: "setting_repository/keyStateChip",
      apiResponse: 'documents/apiResponse'
    }),
    ...mapState(['search_state', 'tags', 'currentCompany', 'session_information']),
    ...mapFields('documents', [
      'statesFilter', 'selectedStateChip', 'documentListFiltersData2', 'documentListOptions', 'documentListKind',
      'documentsListFilters', 'metadataFiltersStates', 'selected', 'documentListAction', 'action', 'documentListActionGroups','documentActionsErrorParams',
    ]),

    ...mapFields('documents',vuexPrefix('doc_filters_',[
      'id', 'state', 'search__icontains', 'search__duplicate', 'entry_number__icontains', 'has_payment_entry', 'paid_account', 'account_move_number__icontains', 'tags', 'username__icontains', 'kind', 'created__gte', 'created__lte', 'accounting_date__gte', 'accounting_date__lte',
      'invoice_date__gte', 'invoice_date__lte', 'metadata__due_date__gte', 'metadata__due_date__lte', 'third_cif__icontains', 'third_name__icontains', 'document_text__icontains',
      'mirror_state', 'ejercicio', 'punteado', 'actividad_str', 'actividad', 'payment_state', 'payment_date__gte', 'payment_date__lte',
      'is_rectificativa', 'has_retention', 'notes__icontains', 'review_reasons__icontains', 'project', "channel", "section", "delegation", "department"
    ], 'documentListFiltersData2.')),
    ...mapFields('documents',vuexPrefix2('doc_filters_', ['value'], 'documentListFiltersData2.', [
      'id', 'state', 'payment_state', 'search__icontains', 'entry_number__icontains', 'has_payment_entry', 'paid_account', 'account_move_number__icontains', 'search__duplicate', 'tags', 'username__icontains', 'kind', 'created__gte', 'created__lte',
      'accounting_date__gte', 'accounting_date__lte', 'invoice_date__gte', 'invoice_date__lte', 'metadata__due_date__gte',
      'metadata__due_date__lte', 'third_cif__icontains', 'third_name__icontains', 'document_text__icontains', 'mirror_state',
      'ejercicio', 'punteado', 'actividad_str', 'actividad', 'payment_date__gte', 'payment_date__lte', 'is_rectificativa','has_retention', 'notes__icontains', 'review_reasons__icontains',
      'project', 'channel', "section", "delegation", "department"
    ])),
    ...mapFields('me', vuexPrefix('', [
          'feature_apply_347'  
        ],
        'userData.available_features.'
      )
    ),
    ...mapFields({
      downloadJobState: 'downloadJobState',
      asyncJobId: 'asyncJobId',
      projects: 'projects',
      channels: 'channels',
      activities: 'activities',
      sections: 'sections',
      delegations: 'delegations',
      departments: 'departments',
    }),

    im_staff_or_loginas() {
      return (this.userData && this.userData.is_staff) || (this.session_information && this.userData.username && this.session_information.username != this.userData.username )
    },
    getActions() {
      let actions = {};
      for (let i in this.documentListAction) {
        let group = this.documentListAction[i]['group'];
        if (!actions.hasOwnProperty(group)) {
          actions[group] = [];
        }
        let keys = Object.keys(this.documentListAction[i]);
        if (this.permission.is_readonly) {
          if (this.got_feature('feature_delete_docs_ro') && this.documentListAction[i]['id'] == 'delete_doc') {
            actions[group].push(this.documentListAction[i]);
          }
          if (this.got_feature('feature_download_docs_excel_ro') && this.documentListAction[i]['id'] == 'download_excel') {
            actions[group].push(this.documentListAction[i]);
          }
          if (this.got_feature('feature_download_docs_file_ro') && this.documentListAction[i]['id'] == 'download_doc') {
            actions[group].push(this.documentListAction[i]);
          }
        }
        else {
          if (!keys.includes('is_staff') && !keys.includes('loginas') && !keys.includes('can_see_training_documents') && !keys.includes('feature') && !keys.includes('show_params') && !keys.includes('not_param') && !keys.includes('company_automatic_accounts')) {
            actions[group].push(this.documentListAction[i]);
          } else if (keys.includes('is_staff') && (this.userData && this.userData.is_staff)) {
            actions[group].push(this.documentListAction[i]);
          } else if (keys.includes('loginas') && (this.userData && this.session_information && this.session_information.username != this.userData.username))  {
            if (keys.includes('show_params')) {
              if (this.hasMasterPermission(this.documentListAction[i]['show_params'])) {
                actions[group].push(this.documentListAction[i]);
              }
            } else {
              actions[group].push(this.documentListAction[i]);
            }
          } else if (keys.includes('can_see_training_documents') && (this.userData && this.userData.can_see_training_documents)) {
            actions[group].push(this.documentListAction[i]);
          } else if (keys.includes('not_param') && (!(this.currentCompany && this.currentCompany.companydb_type && this.currentCompany.companydb_type.params && this.currentCompany.companydb_type.params[this.documentListAction[i]['not_param']]))) {
            actions[group].push(this.documentListAction[i]);
          } else if (keys.includes('feature') && keys.includes('company_automatic_accounts')) {
            if (this.userData && this.userData.available_features[this.documentListAction[i]['feature']] && this.currentCompany && (this.currentCompany.automatic_charge_account || this.currentCompany.automatic_payment_account)) {
              actions[group].push(this.documentListAction[i]);
            }
          } else if (keys.includes('feature') && keys.includes('show_params')) {
            if (this.userData && this.userData.available_features[this.documentListAction[i]['feature']]) {
              if (this.hasMasterPermission(this.documentListAction[i]['show_params'])) {
                actions[group].push(this.documentListAction[i]);
              }
            }
          } else if (keys.includes('feature')) {
            if (this.userData && this.userData.available_features[this.documentListAction[i]['feature']]) {
              actions[group].push(this.documentListAction[i]);
            }
          } else if (keys.includes('show_params')) {
            if (this.hasMasterPermission(this.documentListAction[i]['show_params'])) {
              actions[group].push(this.documentListAction[i]);
            }
          }
          // else {
          //   actions.push(this.documentListAction[i])
          // }
          }
      }
      if (this.currentCompany && this.currentCompany.companydb_type.value == 'inbox') {
        let id_transfer =  this.documentListAction.findIndex((x)=>x.id==='transferir')
        actions.btn = [this.documentListAction[id_transfer]]
      } else if (this.currentCompany && ['csv_asientos', 'csv_facturas'].includes(this.currentCompany.companydb_type.value)) {
        let id_download = this.documentListAction.findIndex((x)=>x.id==='download_cdb_csv')
        actions.btn = [this.documentListAction[id_download]]
      } else if (!this.permission.is_readonly){
        let id_contabilizar =  this.documentListAction.findIndex((x)=>x.id==='contabilizar');
        actions.btn = [this.documentListAction[id_contabilizar]]
      }
      Object.keys(actions).forEach(function(key) {
        if (actions[key].length == 0) {
          delete actions[key];
        }
      });
      // Deshabilitar merge_docs si hay documentos Excel o XML seleccionados
      if (actions.action) {
        actions.action = actions.action.map(item => {
          if (item.id === 'merge_docs') {
            return { ...item, disabled: this.hasNonMergeableSelected };
          }
          return item;
        });
      }
      return actions;
    },
    hasNonMergeableSelected() {
      if (!this.selected || this.selected.length === 0) return false;
      const restrictExtensions = this.$store.state.documents.restrictExtensions.merge || [];
      return this.selected.some(doc => {
        if (!doc.original_file_name) return false;
        const fileName = doc.original_file_name.toLowerCase();
        return restrictExtensions.some(ext => fileName.endsWith(`.${ext}`));
      });
    },
    // Barra de filtros nueva - computed property que enriquece los filtros con valores para los selects
    enrichedDocumentListFiltersData2() {
      if (!this.documentListFiltersData2) return {};

      // Clonar el objeto para no mutar el original
      const enrichedFilters = JSON.parse(JSON.stringify(this.documentListFiltersData2));

      // Obtener datos del store raíz directamente para evitar problemas con mapFields
      const storeState = this.$store.state;

      // Añadir valores para project
      if (enrichedFilters.project && this.currentCompany && this.currentCompany.projects && this.currentCompany.projects.length > 0) {
        enrichedFilters.project.user_values = this.currentCompany.projects.map(p => ({
          value: p.id,
          text: p.name
        }));
      }

      // Añadir valores para channel
      if (enrichedFilters.channel && this.currentCompany && this.currentCompany.channels && this.currentCompany.channels.length > 0) {
        enrichedFilters.channel.user_values = this.currentCompany.channels.map(c => ({
          value: c.channel_id,
          text: c.name
        }));
      }

      // Añadir valores para section (usar $store.state directamente)
      if (enrichedFilters.section && storeState.sections && storeState.sections.length > 0) {
        enrichedFilters.section.user_values = storeState.sections.map(s => ({
          value: s.section_id,
          text: s.name
        }));
      }

      // Añadir valores para delegation (usar $store.state directamente)
      if (enrichedFilters.delegation && storeState.delegations && storeState.delegations.length > 0) {
        enrichedFilters.delegation.user_values = storeState.delegations.map(d => ({
          value: d.delegation_id,
          text: d.name
        }));
      }

      // Añadir valores para department (usar $store.state directamente)
      if (enrichedFilters.department && storeState.departments && storeState.departments.length > 0) {
        enrichedFilters.department.user_values = storeState.departments.map(d => ({
          value: d.department_id,
          text: d.name
        }));
      }

      // Añadir valores para actividad (usar $store.state.activities directamente)
      // Cambiar tipo a 'select' cuando hay actividades disponibles
      if (enrichedFilters.actividad && storeState.activities && storeState.activities.length > 0) {
        enrichedFilters.actividad.user_values = storeState.activities.map(a => ({
          value: a.code,
          text: a.name
        }));
        enrichedFilters.actividad.type = 'select'; // Cambiar a select cuando hay datos
      }

      // Añadir valores para actividad_str (usar $store.state.activities directamente)
      // Cambiar tipo a 'select' cuando hay actividades disponibles
      if (enrichedFilters.actividad_str && storeState.activities && storeState.activities.length > 0) {
        enrichedFilters.actividad_str.user_values = storeState.activities.map(a => ({
          value: a.code,
          text: a.name
        }));
        enrichedFilters.actividad_str.type = 'select'; // Cambiar a select cuando hay datos
      }

      // Añadir valores para ejercicio (desde currentCompany.links)
      if (enrichedFilters.ejercicio && this.currentCompany && this.currentCompany.links && this.currentCompany.links.length > 0) {
        enrichedFilters.ejercicio.user_values = this.currentCompany.links.map(link => ({
          value: link.id,
          text: this.getEjercicioItemText(link)
        }));
        // Si hay un value pero no text, calcular el text desde user_values
        if (enrichedFilters.ejercicio.value && !enrichedFilters.ejercicio.text) {
          const selectedLink = this.currentCompany.links.find(link => link.id === enrichedFilters.ejercicio.value);
          if (selectedLink) {
            enrichedFilters.ejercicio.text = this.getEjercicioItemText(selectedLink);
          }
        }
      }

      return enrichedFilters;
    },
    getFiltersConditions(){
      return {
        'ejercicio': this.userData.available_features['feature_filter_by_ejercicio'],
        'text__icontains': this.userData.available_features['feature_document_text_filter'],
        'tags': this.doc_filters_tags.values && (this.userData.is_staff || (this.userData.hasOwnProperty('username') &&
            this.session_information.hasOwnProperty('username') &&
            (this.session_information.username != this.userData.username))),
        'actividad_str': this.showFilterActividadStr(),
        'actividad': this.showFilterActividadSelect(),
        'username__icontains': this.userData.can_see_training_documents,
        'created__gte': this.userData.available_features.feature_can_see_doc_created_date,
        'created__lte': this.userData.available_features.feature_can_see_doc_created_date,
        'accounting_date__gte': this.userData.available_features.feature_can_see_doc_accounting_date,
        'accounting_date__lte': this.userData.available_features.feature_can_see_doc_accounting_date,
        // 'invoice_date__gte': this.metadataFiltersStates.includes(selectedStateChip),
        // 'invoice_date__lte': this.metadataFiltersStates.includes(selectedStateChip),
        // TODO: State caso especial pendiente revisar tiene else-if
        'state': this.userData.is_staff || (this.userData.hasOwnProperty('username') &&
            this.session_information.hasOwnProperty('username') && (this.session_information.username != this.userData.username)),
        'mirror_state': this.userData.is_staff || (this.userData.hasOwnProperty('username') && this.session_information.hasOwnProperty('username') && (this.session_information.username != this.userData.username)),
        'punteado': this.userData.available_features['feature_can_mark_doc_as_punteado'],
        'is_rectificativa': this.got_feature('feature_is_rectificativa_on_document_list'),
        'has_retention': this.got_feature('feature_filter_has_retention'),
        'payment_state': this.userData.available_features['feature_bank_reconciliation'],
        'payment_date__gte': this.userData.available_features['feature_bank_reconciliation'],
        'payment_date__lte': this.userData.available_features['feature_bank_reconciliation'],
        'notes__icontains': this.userData.available_features['feature_invoice_notes'],
        'review_reasons__icontains': true,
        'has_payment_entry': true,
        'paid_account': true,
      }
    },
    // Filtros iniciales para la barra de búsqueda (chips que se muestran al cargar)
    initialFiltersForSearchBar() {
      const filters = [];
      // Si hay un valor de ejercicio establecido, incluirlo como filtro inicial
      if (this.doc_filters_ejercicio_value && this.enrichedDocumentListFiltersData2.ejercicio) {
        filters.push(this.enrichedDocumentListFiltersData2.ejercicio);
      }
      return filters;
    },
    migrateSameCompanySelected() {
      if (this.migrateDoneSelectedCompany && this.currentCompany) {
        return this.migrateDoneSelectedCompany.id == this.currentCompany.id
      }
      else return false
    }
  },
  watch: {
    currentCompany: {
      handler(newVal) {
        console.log('[WATCH] currentCompany cambió:', newVal);
        if (newVal && newVal.id) {
          console.log('[WATCH] Llamando a loadPaymentAccounts');
          this.loadPaymentAccounts();
          // Actualizar texto del ejercicio cuando los links estén disponibles
          if (newVal.links && newVal.links.length > 0 && this.doc_filters_ejercicio_value) {
            const ejercicioText = this.getEjercicioActualText();
            if (ejercicioText) {
              this.updateObject({key: 'ejercicio', value: this.doc_filters_ejercicio_value, text: ejercicioText});
            }
          }
        }
      },
      immediate: false
    },
    showFilters() {
      // Recalcular altura cuando cambia la visibilidad de los filtros
      // Esperar a que el DOM se actualice completamente con los filtros desplegados
      setTimeout(() => {
        this.calculateTableHeight();
      }, 100);
    },
    selectedFiscal() {
      setTimeout(() => {
        this.lastSelectedFiscal = this.selectedFiscal;
      })
    },
    selectedInversion() {
        setTimeout(() => {
          this.lastSelectedInversion = this.selectedInversion;
          this.bien_inversion = this.selectedInversion? true : false;
        })
    },
    selectedCriterioCaja() {
        setTimeout(() => {
            this.lastSelectedCriterioCaja = this.selectedCriterioCaja;
            this.criterio_de_caja = this.selectedCriterioCaja? true: false;
        })
    },
    // selectedIsComercianteMinorista() {
    //   setTimeout(() => {
    //     this.lastSelectedIsComercianteMinorista = this.selectedIsComercianteMinorista;
    //     this.is_comerciante_minorista = this.selectedIsComercianteMinorista? true: false;
    //   });
    // },
    selectedIvaCheck() {
        setTimeout(() => {
            this.lastSelectedIvaCheck = this.selectedIvaCheck;
        })
    },
    selectedDeducibilidad() {
        setTimeout(() => {
            this.lastSelectedDeducibilidad = this.selectedDeducibilidad;
        })
    },
  },
};
</script>

<style lang="scss">

.red {
  background-color: red;
}

.blue {
  background-color: blue;
}

.green {
  background-color: green;
}

.yellow {
  background-color: yellow;
}

.gsidiv {
    border-radius: 16px;
    color: white;
    font-size: 14px;
    align-items: center;
    cursor: default;
    display: inline-flex;
    line-height: 20px;
    outline: none;
    padding: 0 12px;
    position: relative;
    text-decoration: none;
    transition-duration: .28s;
    transition-property: box-shadow,opacity;
    transition-timing-function: cubic-bezier(.4,0,.2,1);
    vertical-align: middle;
    min-height: 32px;
}

.title-color {
    color:var(--v-primary-base);
}


tbody {
  tr {
    display: table-row;
  }
  tr:hover {
    background: rgb(102, 51, 153, 0.1) !important;
    color: var(--v-primary-base);
  }

}
.primary-bckground {
  background-color: var(--v-primary-base);
}
.primary-border {
  border-color: var(--v-primary-base) !important;
}
.chiptext {
  max-width: 80%;
}

.massive-info {
  font-size: 16px;
}

.check-info > .v-input__control > .v-input__slot > .v-input--selection-controls__input {
  margin-right: 0px !important;
}

</style>
<style scoped>
.check-info > .v-input__control > .v-input__slot > .v-input--selection-controls__input {
  margin-right: 0px !important;
}

.rounded-top {
  border-top-left-radius: 10px !important;
  border-top-right-radius: 10px !important;
}
.btn-minus-plus{
  width:10px !important;
  height:10px !important;
}
.upload-invoices {
  text-transform: none;
}
</style>

<!-- Mobile -->

<style>
@media (max-width: 960px) {
  .container,
  .col-12 {
    padding: 0px !important;
  }

  .mobile-container_table {
    margin-top: 10px;
  }

  .v-toolbar__content {
    width: -webkit-fill-available;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    flex-direction: row;
    align-content: center;
    justify-content: center;
    align-items: center;
  }

  .v-card__title {
    position: sticky;
    top: 0;
    z-index: 2;
  }

  .card-title-mobile-mode  {
    .spacer {
      display: none !important;
      flex-grow: 0 !important;
    }

    .v-toolbar__content {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      align-content: center;
      align-items: center;
      justify-content: center;
    }
  }

}
</style>

<style>
.mobile-table .v-data-table__wrapper table thead tr th {
  background-color: #f5f5f5 !important;
  color: var(--v-primary-base) !important;
  font-weight: bold !important;
  font-size: 14px !important;
  text-transform: uppercase;
}
.mobile-container_table .v-data-footer {
    display: flex;
    justify-content: center;
}
.app-btn--modifier {
  margin-bottom: 5px;
}
</style>

<style>
.v-input__slot{
  width: 100% !important
}

.section-tax-options {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
</style>
